/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Home API
 * Aggregated home page data endpoint.

Returns all home page sections in a single response with server-side caching (10 min TTL).
Public data (dummy products excluded) is cached per month.
Privileged users (admin/editor) always receive fresh data including dummy products.

 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Returns all sections of the home page in one request.
Results are cached for 10 minutes per month for non-privileged users.

 * @summary Get aggregated home page data
 */
export const getHomeDataQueryMonthRegExp = new RegExp("^\\d{4}-\\d{2}$");

export const GetHomeDataQueryParams = zod
    .object({
        month: zod
            .string()
            .regex(getHomeDataQueryMonthRegExp)
            .optional()
            .describe("Target month for ranking data (YYYY-MM). Defaults to previous month."),
    })
    .strict();

export const getHomeData200ResponseDataTopBannerOneImagePathMax = 150;

export const getHomeData200ResponseDataTopBannerOneAdTitleMax = 40;

export const getHomeData200ResponseDataTopBannerOneAdBodyMax = 130;

export const getHomeData200ResponseDataTopBannerOneLinkUrlMax = 500;

export const getHomeData200ResponseDataSectionBannersItemImagePathMax = 150;

export const getHomeData200ResponseDataSectionBannersItemAdTitleMax = 40;

export const getHomeData200ResponseDataSectionBannersItemAdBodyMax = 130;

export const getHomeData200ResponseDataSectionBannersItemLinkUrlMax = 500;

export const getHomeData200ResponseDataPlaceholderAdsItemImagePathMax = 150;

export const getHomeData200ResponseDataPlaceholderAdsItemAdTitleMax = 40;

export const getHomeData200ResponseDataPlaceholderAdsItemAdBodyMax = 130;

export const getHomeData200ResponseDataPlaceholderAdsItemLinkUrlMax = 500;

export const getHomeData200ResponseDataLatestPostsItemPostTitleMax = 300;

export const getHomeData200ResponseDataLatestPostsItemReviewConfigOneReviewConfigNameMax = 70;

export const getHomeData200ResponseDataLatestPostsItemReviewQuestionsItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataLatestPostsItemReviewQuestionsItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataLatestPostsItemReviewQuestionsItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataLatestPostsItemReviewDataOneAnswersItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataLatestPostsItemReviewDataOneAnswersItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataLatestPostsItemReviewDataOneAnswersItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataLatestPostsItemAdsItemImagePathMax = 150;

export const getHomeData200ResponseDataLatestPostsItemAdsItemAdTitleMax = 40;

export const getHomeData200ResponseDataLatestPostsItemAdsItemAdBodyMax = 130;

export const getHomeData200ResponseDataLatestPostsItemAdsItemLinkUrlMax = 500;

export const getHomeData200ResponseDataLatestPostsItemProductOneProductNameMax = 255;

export const getHomeData200ResponseDataLatestPostsItemProductOneBrandNameMax = 100;

export const getHomeData200ResponseDataLatestPostsItemProductOneCategoryNameMax = 100;

export const getHomeData200ResponseDataLatestPostsItemProductOnePriceUnitMax = 10;

export const getHomeData200ResponseDataLatestPostsItemProductOneUnitMax = 100;

export const getHomeData200ResponseDataLatestPostsItemProductOneKeywordMax = 500;

export const getHomeData200ResponseDataLatestPostsItemProductOneParentCategoryNameMax = 100;

export const getHomeData200ResponseDataLatestPostsItemProductOneReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataLatestPostsItemProductOneReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataLatestPostsItemBoardNameThMax = 100;

export const getHomeData200ResponseDataLatestPostsItemBoardNameEnMax = 100;

export const getHomeData200ResponseDataLatestPostsItemBoardNameJaMax = 100;

export const getHomeData200ResponseDataLatestPostsItemBoardDescriptionThMax = 255;

export const getHomeData200ResponseDataLatestPostsItemBoardDescriptionEnMax = 255;

export const getHomeData200ResponseDataLatestPostsItemBoardDescriptionJaMax = 255;

export const getHomeData200ResponseDataLatestPostsItemBoardFixedTitleMax = 500;

export const getHomeData200ResponseDataLatestPostsItemUserDisplayNameMax = 50;

export const getHomeData200ResponseDataLatestPostsItemUserFirstNameMax = 100;

export const getHomeData200ResponseDataLatestPostsItemUserLastNameMax = 100;

export const getHomeData200ResponseDataLatestPostsItemUserNickNameMax = 50;

export const getHomeData200ResponseDataLatestPostsItemUserPreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataLatestPostsItemUserSocialInstagramMax = 100;

export const getHomeData200ResponseDataLatestPostsItemUserSocialFacebookMax = 100;

export const getHomeData200ResponseDataLatestPostsItemUserSocialXMax = 100;

export const getHomeData200ResponseDataLatestPostsItemUserSocialTiktokMax = 100;

export const getHomeData200ResponseDataLatestPostsItemUserSocialYoutubeMax = 100;

export const getHomeData200ResponseDataLatestPostsItemUserSocialWebsiteMax = 500;

export const getHomeData200ResponseDataLatestPostsItemUserAvatarMax = 255;

export const getHomeData200ResponseDataSnsReviewsItemPostTitleMax = 300;

export const getHomeData200ResponseDataSnsReviewsItemReviewConfigOneReviewConfigNameMax = 70;

export const getHomeData200ResponseDataSnsReviewsItemReviewQuestionsItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataSnsReviewsItemReviewQuestionsItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataSnsReviewsItemReviewQuestionsItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataSnsReviewsItemReviewDataOneAnswersItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataSnsReviewsItemReviewDataOneAnswersItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataSnsReviewsItemReviewDataOneAnswersItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataSnsReviewsItemAdsItemImagePathMax = 150;

export const getHomeData200ResponseDataSnsReviewsItemAdsItemAdTitleMax = 40;

export const getHomeData200ResponseDataSnsReviewsItemAdsItemAdBodyMax = 130;

export const getHomeData200ResponseDataSnsReviewsItemAdsItemLinkUrlMax = 500;

export const getHomeData200ResponseDataSnsReviewsItemProductOneProductNameMax = 255;

export const getHomeData200ResponseDataSnsReviewsItemProductOneBrandNameMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemProductOneCategoryNameMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemProductOnePriceUnitMax = 10;

export const getHomeData200ResponseDataSnsReviewsItemProductOneUnitMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemProductOneKeywordMax = 500;

export const getHomeData200ResponseDataSnsReviewsItemProductOneParentCategoryNameMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemProductOneReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataSnsReviewsItemProductOneReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataSnsReviewsItemBoardNameThMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemBoardNameEnMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemBoardNameJaMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemBoardDescriptionThMax = 255;

export const getHomeData200ResponseDataSnsReviewsItemBoardDescriptionEnMax = 255;

export const getHomeData200ResponseDataSnsReviewsItemBoardDescriptionJaMax = 255;

export const getHomeData200ResponseDataSnsReviewsItemBoardFixedTitleMax = 500;

export const getHomeData200ResponseDataSnsReviewsItemUserDisplayNameMax = 50;

export const getHomeData200ResponseDataSnsReviewsItemUserFirstNameMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemUserLastNameMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemUserNickNameMax = 50;

export const getHomeData200ResponseDataSnsReviewsItemUserPreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataSnsReviewsItemUserSocialInstagramMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemUserSocialFacebookMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemUserSocialXMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemUserSocialTiktokMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemUserSocialYoutubeMax = 100;

export const getHomeData200ResponseDataSnsReviewsItemUserSocialWebsiteMax = 500;

export const getHomeData200ResponseDataSnsReviewsItemUserAvatarMax = 255;

export const getHomeData200ResponseDataRankingProductsParentCategoriesItemLabelMax = 100;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneProductNameMax = 255;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneProductUrlMax = 2048;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneImageMax = 255;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneBrandNameMax = 100;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOnePriceUnitMax = 10;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneUnitMax = 100;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneKeywordMax = 500;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneParentCategoryNameMax = 100;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryNameMax = 100;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryCategoryNameMax = 100;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryCategoryIconMax = 40;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryParentCategoryNameMax = 100;

export const getHomeData200ResponseDataRankingProductsRankingsByParentItemOneBrandBrandNameMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneDisplayNameMax = 50;

export const getHomeData200ResponseDataRankingUsersItemOneFirstNameMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneLastNameMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneNickNameMax = 50;

export const getHomeData200ResponseDataRankingUsersItemOnePreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataRankingUsersItemOneSocialInstagramMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneSocialFacebookMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneSocialXMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneSocialTiktokMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneSocialYoutubeMax = 100;

export const getHomeData200ResponseDataRankingUsersItemOneSocialWebsiteMax = 500;

export const getHomeData200ResponseDataRankingUsersItemOneAvatarMax = 255;

export const getHomeData200ResponseDataReviewAwardsItemProductNameMax = 255;

export const getHomeData200ResponseDataReviewAwardsItemProductUrlMax = 2048;

export const getHomeData200ResponseDataReviewAwardsItemImageMax = 255;

export const getHomeData200ResponseDataReviewAwardsItemBrandNameMax = 100;

export const getHomeData200ResponseDataReviewAwardsItemPriceUnitMax = 10;

export const getHomeData200ResponseDataReviewAwardsItemUnitMax = 100;

export const getHomeData200ResponseDataReviewAwardsItemKeywordMax = 500;

export const getHomeData200ResponseDataReviewAwardsItemParentCategoryNameMax = 100;

export const getHomeData200ResponseDataReviewAwardsItemCategoryNameMax = 100;

export const getHomeData200ResponseDataReviewAwardsItemReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataReviewAwardsItemReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataReviewAwardsItemCategoryCategoryNameMax = 100;

export const getHomeData200ResponseDataReviewAwardsItemCategoryCategoryIconMax = 40;

export const getHomeData200ResponseDataReviewAwardsItemCategoryParentCategoryNameMax = 100;

export const getHomeData200ResponseDataReviewAwardsItemBrandBrandNameMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemPostTitleMax = 300;

export const getHomeData200ResponseDataRecommendReviewsItemReviewConfigOneReviewConfigNameMax = 70;

export const getHomeData200ResponseDataRecommendReviewsItemReviewQuestionsItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataRecommendReviewsItemReviewQuestionsItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataRecommendReviewsItemReviewQuestionsItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataRecommendReviewsItemReviewDataOneAnswersItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataRecommendReviewsItemReviewDataOneAnswersItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataRecommendReviewsItemReviewDataOneAnswersItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataRecommendReviewsItemAdsItemImagePathMax = 150;

export const getHomeData200ResponseDataRecommendReviewsItemAdsItemAdTitleMax = 40;

export const getHomeData200ResponseDataRecommendReviewsItemAdsItemAdBodyMax = 130;

export const getHomeData200ResponseDataRecommendReviewsItemAdsItemLinkUrlMax = 500;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneProductNameMax = 255;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneBrandNameMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneCategoryNameMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemProductOnePriceUnitMax = 10;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneUnitMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneKeywordMax = 500;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneParentCategoryNameMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataRecommendReviewsItemProductOneReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataRecommendReviewsItemBoardNameThMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemBoardNameEnMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemBoardNameJaMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemBoardDescriptionThMax = 255;

export const getHomeData200ResponseDataRecommendReviewsItemBoardDescriptionEnMax = 255;

export const getHomeData200ResponseDataRecommendReviewsItemBoardDescriptionJaMax = 255;

export const getHomeData200ResponseDataRecommendReviewsItemBoardFixedTitleMax = 500;

export const getHomeData200ResponseDataRecommendReviewsItemUserDisplayNameMax = 50;

export const getHomeData200ResponseDataRecommendReviewsItemUserFirstNameMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemUserLastNameMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemUserNickNameMax = 50;

export const getHomeData200ResponseDataRecommendReviewsItemUserPreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataRecommendReviewsItemUserSocialInstagramMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemUserSocialFacebookMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemUserSocialXMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemUserSocialTiktokMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemUserSocialYoutubeMax = 100;

export const getHomeData200ResponseDataRecommendReviewsItemUserSocialWebsiteMax = 500;

export const getHomeData200ResponseDataRecommendReviewsItemUserAvatarMax = 255;

export const getHomeData200ResponseDataRecommendUsersItemDisplayNameMax = 50;

export const getHomeData200ResponseDataRecommendUsersItemFirstNameMax = 100;

export const getHomeData200ResponseDataRecommendUsersItemLastNameMax = 100;

export const getHomeData200ResponseDataRecommendUsersItemNickNameMax = 50;

export const getHomeData200ResponseDataRecommendUsersItemPreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataRecommendUsersItemSocialInstagramMax = 100;

export const getHomeData200ResponseDataRecommendUsersItemSocialFacebookMax = 100;

export const getHomeData200ResponseDataRecommendUsersItemSocialXMax = 100;

export const getHomeData200ResponseDataRecommendUsersItemSocialTiktokMax = 100;

export const getHomeData200ResponseDataRecommendUsersItemSocialYoutubeMax = 100;

export const getHomeData200ResponseDataRecommendUsersItemSocialWebsiteMax = 500;

export const getHomeData200ResponseDataRecommendUsersItemAvatarMax = 255;

export const getHomeData200ResponseDataArticlesBeautyNewsItemPostTitleMax = 300;

export const getHomeData200ResponseDataArticlesBeautyNewsItemReviewConfigOneReviewConfigNameMax = 70;

export const getHomeData200ResponseDataArticlesBeautyNewsItemReviewQuestionsItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataArticlesBeautyNewsItemReviewQuestionsItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataArticlesBeautyNewsItemReviewQuestionsItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataArticlesBeautyNewsItemReviewDataOneAnswersItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataArticlesBeautyNewsItemReviewDataOneAnswersItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataArticlesBeautyNewsItemReviewDataOneAnswersItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemImagePathMax = 150;

export const getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemAdTitleMax = 40;

export const getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemAdBodyMax = 130;

export const getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemLinkUrlMax = 500;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneProductNameMax = 255;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneBrandNameMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneCategoryNameMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOnePriceUnitMax = 10;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneUnitMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneKeywordMax = 500;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneParentCategoryNameMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataArticlesBeautyNewsItemProductOneReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataArticlesBeautyNewsItemBoardNameThMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemBoardNameEnMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemBoardNameJaMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemBoardDescriptionThMax = 255;

export const getHomeData200ResponseDataArticlesBeautyNewsItemBoardDescriptionEnMax = 255;

export const getHomeData200ResponseDataArticlesBeautyNewsItemBoardDescriptionJaMax = 255;

export const getHomeData200ResponseDataArticlesBeautyNewsItemBoardFixedTitleMax = 500;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserDisplayNameMax = 50;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserFirstNameMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserLastNameMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserNickNameMax = 50;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserPreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialInstagramMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialFacebookMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialXMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialTiktokMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialYoutubeMax = 100;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialWebsiteMax = 500;

export const getHomeData200ResponseDataArticlesBeautyNewsItemUserAvatarMax = 255;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemPostTitleMax = 300;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemReviewConfigOneReviewConfigNameMax = 70;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemReviewQuestionsItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemReviewQuestionsItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemReviewQuestionsItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemReviewDataOneAnswersItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemReviewDataOneAnswersItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemReviewDataOneAnswersItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemImagePathMax = 150;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemAdTitleMax = 40;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemAdBodyMax = 130;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemLinkUrlMax = 500;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneProductNameMax = 255;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneBrandNameMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneCategoryNameMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOnePriceUnitMax = 10;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneUnitMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneKeywordMax = 500;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneParentCategoryNameMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemBoardNameThMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemBoardNameEnMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemBoardNameJaMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemBoardDescriptionThMax = 255;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemBoardDescriptionEnMax = 255;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemBoardDescriptionJaMax = 255;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemBoardFixedTitleMax = 500;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserDisplayNameMax = 50;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserFirstNameMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserLastNameMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserNickNameMax = 50;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserPreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialInstagramMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialFacebookMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialXMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialTiktokMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialYoutubeMax = 100;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialWebsiteMax = 500;

export const getHomeData200ResponseDataArticlesEditorialReviewsItemUserAvatarMax = 255;

export const getHomeData200ResponseDataArticlesExpertReviewsItemPostTitleMax = 300;

export const getHomeData200ResponseDataArticlesExpertReviewsItemReviewConfigOneReviewConfigNameMax = 70;

export const getHomeData200ResponseDataArticlesExpertReviewsItemReviewQuestionsItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataArticlesExpertReviewsItemReviewQuestionsItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataArticlesExpertReviewsItemReviewQuestionsItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataArticlesExpertReviewsItemReviewDataOneAnswersItemQuestionTextThMax = 200;

export const getHomeData200ResponseDataArticlesExpertReviewsItemReviewDataOneAnswersItemQuestionTextEnMax = 200;

export const getHomeData200ResponseDataArticlesExpertReviewsItemReviewDataOneAnswersItemQuestionTextJaMax = 200;

export const getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemImagePathMax = 150;

export const getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemAdTitleMax = 40;

export const getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemAdBodyMax = 130;

export const getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemLinkUrlMax = 500;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneProductNameMax = 255;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneBrandNameMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneCategoryNameMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOnePriceUnitMax = 10;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneUnitMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneKeywordMax = 500;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneParentCategoryNameMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneReviewSummaryEnMax = 500;

export const getHomeData200ResponseDataArticlesExpertReviewsItemProductOneReviewSummaryJaMax = 500;

export const getHomeData200ResponseDataArticlesExpertReviewsItemBoardNameThMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemBoardNameEnMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemBoardNameJaMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemBoardDescriptionThMax = 255;

export const getHomeData200ResponseDataArticlesExpertReviewsItemBoardDescriptionEnMax = 255;

export const getHomeData200ResponseDataArticlesExpertReviewsItemBoardDescriptionJaMax = 255;

export const getHomeData200ResponseDataArticlesExpertReviewsItemBoardFixedTitleMax = 500;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserDisplayNameMax = 50;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserFirstNameMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserLastNameMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserNickNameMax = 50;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserPreferredPriceRangeMax = 50;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialInstagramMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialFacebookMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialXMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialTiktokMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialYoutubeMax = 100;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialWebsiteMax = 500;

export const getHomeData200ResponseDataArticlesExpertReviewsItemUserAvatarMax = 255;

export const GetHomeData200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        data: zod
            .object({
                month: zod.string().describe("Target month for ranking data (YYYY-MM)"),
                top_banner: zod
                    .union([
                        zod
                            .object({
                                ad_id: zod.number().optional(),
                                ad_type: zod
                                    .enum([
                                        "PLACE_HOLDER",
                                        "PRODUCT_LINKER",
                                        "PRODUCT_LINKER_OGP",
                                        "PRODUCT_CARD",
                                        "TOP_BANNER",
                                        "SECTION_BANNER",
                                        "USERS_BANNER",
                                        "USERS_BANNER_RECTANGLE",
                                        "AUTH_BANNER",
                                    ])
                                    .optional(),
                                image_path: zod
                                    .string()
                                    .max(getHomeData200ResponseDataTopBannerOneImagePathMax)
                                    .optional(),
                                ad_title: zod.string().max(getHomeData200ResponseDataTopBannerOneAdTitleMax).optional(),
                                ad_body: zod.string().max(getHomeData200ResponseDataTopBannerOneAdBodyMax).optional(),
                                link_url: zod.string().max(getHomeData200ResponseDataTopBannerOneLinkUrlMax).optional(),
                                is_internal_modal_link: zod.boolean().optional(),
                                modal_board_id: zod.string().nullish(),
                                modal_post_id: zod.number().nullish(),
                                ad_product_id: zod.number().nullish(),
                                display_rate_percent: zod.number().nullish(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Top banner advertisement"),
                        zod.null(),
                    ])
                    .optional()
                    .describe("Top banner ad, or null if none configured"),
                section_banners: zod
                    .array(
                        zod
                            .object({
                                ad_id: zod.number().optional(),
                                ad_type: zod
                                    .enum([
                                        "PLACE_HOLDER",
                                        "PRODUCT_LINKER",
                                        "PRODUCT_LINKER_OGP",
                                        "PRODUCT_CARD",
                                        "TOP_BANNER",
                                        "SECTION_BANNER",
                                        "USERS_BANNER",
                                        "USERS_BANNER_RECTANGLE",
                                        "AUTH_BANNER",
                                    ])
                                    .optional(),
                                image_path: zod
                                    .string()
                                    .max(getHomeData200ResponseDataSectionBannersItemImagePathMax)
                                    .optional(),
                                ad_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataSectionBannersItemAdTitleMax)
                                    .optional(),
                                ad_body: zod
                                    .string()
                                    .max(getHomeData200ResponseDataSectionBannersItemAdBodyMax)
                                    .optional(),
                                link_url: zod
                                    .string()
                                    .max(getHomeData200ResponseDataSectionBannersItemLinkUrlMax)
                                    .optional(),
                                is_internal_modal_link: zod.boolean().optional(),
                                modal_board_id: zod.string().nullish(),
                                modal_post_id: zod.number().nullish(),
                                ad_product_id: zod.number().nullish(),
                                display_rate_percent: zod.number().nullish(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Ad item embedded in a home post response"),
                    )
                    .optional()
                    .describe("SECTION_BANNER ads shown between home page sections"),
                placeholder_ads: zod
                    .array(
                        zod
                            .object({
                                ad_id: zod.number().optional(),
                                ad_type: zod
                                    .enum([
                                        "PLACE_HOLDER",
                                        "PRODUCT_LINKER",
                                        "PRODUCT_LINKER_OGP",
                                        "PRODUCT_CARD",
                                        "TOP_BANNER",
                                        "SECTION_BANNER",
                                        "USERS_BANNER",
                                        "USERS_BANNER_RECTANGLE",
                                        "AUTH_BANNER",
                                    ])
                                    .optional(),
                                image_path: zod
                                    .string()
                                    .max(getHomeData200ResponseDataPlaceholderAdsItemImagePathMax)
                                    .optional(),
                                ad_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataPlaceholderAdsItemAdTitleMax)
                                    .optional(),
                                ad_body: zod
                                    .string()
                                    .max(getHomeData200ResponseDataPlaceholderAdsItemAdBodyMax)
                                    .optional(),
                                link_url: zod
                                    .string()
                                    .max(getHomeData200ResponseDataPlaceholderAdsItemLinkUrlMax)
                                    .optional(),
                                is_internal_modal_link: zod.boolean().optional(),
                                modal_board_id: zod.string().nullish(),
                                modal_post_id: zod.number().nullish(),
                                ad_product_id: zod.number().nullish(),
                                display_rate_percent: zod.number().nullish(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Ad item embedded in a home post response"),
                    )
                    .optional()
                    .describe("PLACE_HOLDER ads shown in place of missing media"),
                latest_posts: zod
                    .array(
                        zod
                            .object({
                                post_id: zod.number(),
                                board_id: zod.enum([
                                    "review",
                                    "tiktoks",
                                    "beauty_news",
                                    "editorial_reviews",
                                    "expert_reviews",
                                    "activities",
                                    "test_modal",
                                    "test_modeless",
                                    "guidance",
                                ]),
                                user_id: zod.number(),
                                post_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataLatestPostsItemPostTitleMax)
                                    .optional(),
                                content: zod.string().optional(),
                                post_product_id: zod.number().nullish(),
                                product_brand_name: zod.string().nullish(),
                                product_category_id: zod.number().nullish(),
                                product_category_name: zod.string().nullish(),
                                product_parent_category_id: zod.number().nullish(),
                                product_parent_category_name: zod.string().nullish(),
                                recommend_rank: zod.number().min(1).nullish(),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Average review rating (review-board posts only), derived from the post's rating answers. null when the post has no rating answers or is not a review post.\n",
                                    ),
                                attached_images: zod.array(zod.string()).optional(),
                                likes_count: zod.number().nullish(),
                                reads_count: zod.number().nullish(),
                                attached_videos: zod.array(zod.string()).optional(),
                                content_images: zod.array(zod.string()).optional(),
                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                comments_count: zod.number().nullish(),
                                sns_links: zod.array(zod.string().url()).optional(),
                                monthly_rank: zod.number().nullish(),
                                sns_shares: zod.array(zod.string()).optional(),
                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                reviews_count: zod.number().nullish(),
                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                has_user_reviewed: zod.boolean().optional(),
                                review_config: zod
                                    .union([
                                        zod
                                            .object({
                                                review_config_id: zod.number().optional(),
                                                review_config_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemReviewConfigOneReviewConfigNameMax,
                                                    )
                                                    .optional(),
                                                general_description: zod.string().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                        zod.null(),
                                    ])
                                    .optional(),
                                review_questions: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemReviewQuestionsItemQuestionTextThMax,
                                                    )
                                                    .optional(),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemReviewQuestionsItemQuestionTextEnMax,
                                                    )
                                                    .optional(),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemReviewQuestionsItemQuestionTextJaMax,
                                                    )
                                                    .optional(),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional(),
                                                option_th: zod.array(zod.string()).optional(),
                                                option_en: zod.array(zod.string()).optional(),
                                                option_ja: zod.array(zod.string()).optional(),
                                                is_required: zod.number().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                review_data: zod
                                    .union([
                                        zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                answers: zod
                                                    .array(
                                                        zod
                                                            .object({
                                                                review_question_id: zod.number().optional(),
                                                                answer_value: zod.string().optional(),
                                                                question_text_th: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataLatestPostsItemReviewDataOneAnswersItemQuestionTextThMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_en: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataLatestPostsItemReviewDataOneAnswersItemQuestionTextEnMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_ja: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataLatestPostsItemReviewDataOneAnswersItemQuestionTextJaMax,
                                                                    )
                                                                    .optional(),
                                                                question_type: zod.string().optional(),
                                                                option_th: zod.array(zod.string()).optional(),
                                                                option_en: zod.array(zod.string()).optional(),
                                                                option_ja: zod.array(zod.string()).optional(),
                                                                answer_value_th: zod.string().optional(),
                                                                answer_value_en: zod.string().optional(),
                                                                answer_value_ja: zod.string().optional(),
                                                            })
                                                            .strict()
                                                            .describe(
                                                                "Question text\/options\/localized answer values are denormalized onto each answer for display convenience.",
                                                            ),
                                                    )
                                                    .optional(),
                                            })
                                            .strict()
                                            .describe(
                                                "Current user's review data for this post (null if not reviewed)",
                                            ),
                                        zod.null(),
                                    ])
                                    .optional(),
                                ads: zod
                                    .array(
                                        zod
                                            .object({
                                                ad_id: zod.number().optional(),
                                                ad_type: zod
                                                    .enum([
                                                        "PLACE_HOLDER",
                                                        "PRODUCT_LINKER",
                                                        "PRODUCT_LINKER_OGP",
                                                        "PRODUCT_CARD",
                                                        "TOP_BANNER",
                                                        "SECTION_BANNER",
                                                        "USERS_BANNER",
                                                        "USERS_BANNER_RECTANGLE",
                                                        "AUTH_BANNER",
                                                    ])
                                                    .optional(),
                                                image_path: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataLatestPostsItemAdsItemImagePathMax)
                                                    .optional(),
                                                ad_title: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataLatestPostsItemAdsItemAdTitleMax)
                                                    .optional(),
                                                ad_body: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataLatestPostsItemAdsItemAdBodyMax)
                                                    .optional(),
                                                link_url: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataLatestPostsItemAdsItemLinkUrlMax)
                                                    .optional(),
                                                is_internal_modal_link: zod.boolean().optional(),
                                                modal_board_id: zod.string().nullish(),
                                                modal_post_id: zod.number().nullish(),
                                                ad_product_id: zod.number().nullish(),
                                                display_rate_percent: zod.number().nullish(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Ad item embedded in a home post response"),
                                    )
                                    .optional(),
                                product: zod
                                    .union([
                                        zod
                                            .object({
                                                product_id: zod.number().optional(),
                                                product_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemProductOneProductNameMax,
                                                    )
                                                    .optional(),
                                                product_status: zod
                                                    .enum([
                                                        "draft",
                                                        "editing",
                                                        "released",
                                                        "duplicated",
                                                        "rejected",
                                                        "dummy",
                                                        "brand",
                                                    ])
                                                    .optional(),
                                                brand_id: zod.number().nullish(),
                                                brand_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemProductOneBrandNameMax,
                                                    )
                                                    .optional(),
                                                category_id: zod.number().nullish(),
                                                category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemProductOneCategoryNameMax,
                                                    )
                                                    .optional(),
                                                image_url: zod.string().optional(),
                                                image: zod.string().optional(),
                                                review_count: zod.number().nullish(),
                                                average_rating: zod.number().nullish(),
                                                recommend_rank: zod.number().nullish(),
                                                general_description: zod.string().optional(),
                                                product_note: zod.string().optional(),
                                                product_url: zod.string().optional(),
                                                price: zod.number().nullish(),
                                                price_unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemProductOnePriceUnitMax,
                                                    )
                                                    .optional(),
                                                group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                                unit: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataLatestPostsItemProductOneUnitMax)
                                                    .optional(),
                                                how_to_use: zod.string().optional(),
                                                ingredients: zod.string().optional(),
                                                keyword: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataLatestPostsItemProductOneKeywordMax)
                                                    .optional(),
                                                created_by: zod.number().nullish(),
                                                updated_by: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod.number().nullish(),
                                                parent_category_id: zod.number().nullish(),
                                                parent_category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemProductOneParentCategoryNameMax,
                                                    )
                                                    .optional(),
                                                likes_count: zod.number().nullish(),
                                                comments_count: zod.number().nullish(),
                                                reads_count: zod.number().nullish(),
                                                review_count_guest: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                posts_count_guest: zod.number().nullish(),
                                                positive_points_th: zod.array(zod.string()).optional(),
                                                negative_points_th: zod.array(zod.string()).optional(),
                                                positive_points_en: zod.array(zod.string()).optional(),
                                                negative_points_en: zod.array(zod.string()).optional(),
                                                positive_points_ja: zod.array(zod.string()).optional(),
                                                negative_points_ja: zod.array(zod.string()).optional(),
                                                review_summary_th: zod.string().optional(),
                                                review_summary_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemProductOneReviewSummaryEnMax,
                                                    )
                                                    .optional(),
                                                review_summary_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataLatestPostsItemProductOneReviewSummaryJaMax,
                                                    )
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Linked product data embedded in a home post response."),
                                        zod.null(),
                                    ])
                                    .optional(),
                                likes: zod
                                    .array(
                                        zod
                                            .object({
                                                like_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                comment_id: zod.number().nullish(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                reads: zod
                                    .array(
                                        zod
                                            .object({
                                                read_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                comments: zod
                                    .array(
                                        zod
                                            .object({
                                                comment_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                content: zod.string().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                board: zod
                                    .object({
                                        board_config_id: zod.number().optional(),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional(),
                                        is_active: zod.number().optional(),
                                        allowed_read_roles: zod.array(zod.string()).optional(),
                                        allowed_write_roles: zod.array(zod.string()).optional(),
                                        allowed_like_roles: zod.array(zod.string()).optional(),
                                        allowed_comment_roles: zod.array(zod.string()).optional(),
                                        comment_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        board_type: zod.enum(["general", "news", "article", "review"]).optional(),
                                        name_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemBoardNameThMax)
                                            .optional(),
                                        name_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemBoardNameEnMax)
                                            .optional(),
                                        name_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemBoardNameJaMax)
                                            .optional(),
                                        description_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemBoardDescriptionThMax)
                                            .optional(),
                                        description_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemBoardDescriptionEnMax)
                                            .optional(),
                                        description_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemBoardDescriptionJaMax)
                                            .optional(),
                                        list_style: zod.enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"]).optional(),
                                        modal_usage: zod
                                            .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                                            .optional(),
                                        modal_size: zod
                                            .enum(["small", "medium", "large", "extra-large", "N/A"])
                                            .optional(),
                                        title_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        fixed_title: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemBoardFixedTitleMax)
                                            .optional(),
                                        product_linker_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        target_product_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        ogp_preview_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        user_info_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        show_content: zod.enum(["SHOW", "HIDE"]).optional(),
                                        rating_overlay_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        date_show: zod.enum(["SHOW", "HIDE"]).nullish(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        review_config_id: zod.number().nullish(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional(),
                                user: zod
                                    .object({
                                        user_id: zod.number(),
                                        display_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserDisplayNameMax)
                                            .optional(),
                                        first_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserFirstNameMax)
                                            .optional(),
                                        last_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserLastNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserNickNameMax)
                                            .optional(),
                                        date_of_birth: zod.string().date().nullish(),
                                        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        skin_concerns: zod.array(zod.string()).optional(),
                                        skin_tone: zod
                                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                            .nullish(),
                                        hair_type: zod
                                            .enum([
                                                "straight_coarse",
                                                "straight_soft",
                                                "wavy_coarse",
                                                "wavy_soft",
                                                "normal_hair",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                        preferred_price_range: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserPreferredPriceRangeMax)
                                            .optional(),
                                        social_instagram: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserSocialInstagramMax)
                                            .optional(),
                                        social_facebook: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserSocialFacebookMax)
                                            .optional(),
                                        social_x: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserSocialXMax)
                                            .optional(),
                                        social_tiktok: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserSocialTiktokMax)
                                            .optional(),
                                        social_youtube: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserSocialYoutubeMax)
                                            .optional(),
                                        social_website: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserSocialWebsiteMax)
                                            .optional(),
                                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        review_count: zod.number().nullish(),
                                        avatar: zod
                                            .string()
                                            .max(getHomeData200ResponseDataLatestPostsItemUserAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        followings_count: zod.number().optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("User item for home page sections"),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Post item for home page sections"),
                    )
                    .describe("Latest review posts (cross-board, sorted by created_at desc)"),
                sns_reviews: zod
                    .array(
                        zod
                            .object({
                                post_id: zod.number(),
                                board_id: zod.enum([
                                    "review",
                                    "tiktoks",
                                    "beauty_news",
                                    "editorial_reviews",
                                    "expert_reviews",
                                    "activities",
                                    "test_modal",
                                    "test_modeless",
                                    "guidance",
                                ]),
                                user_id: zod.number(),
                                post_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataSnsReviewsItemPostTitleMax)
                                    .optional(),
                                content: zod.string().optional(),
                                post_product_id: zod.number().nullish(),
                                product_brand_name: zod.string().nullish(),
                                product_category_id: zod.number().nullish(),
                                product_category_name: zod.string().nullish(),
                                product_parent_category_id: zod.number().nullish(),
                                product_parent_category_name: zod.string().nullish(),
                                recommend_rank: zod.number().min(1).nullish(),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Average review rating (review-board posts only), derived from the post's rating answers. null when the post has no rating answers or is not a review post.\n",
                                    ),
                                attached_images: zod.array(zod.string()).optional(),
                                likes_count: zod.number().nullish(),
                                reads_count: zod.number().nullish(),
                                attached_videos: zod.array(zod.string()).optional(),
                                content_images: zod.array(zod.string()).optional(),
                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                comments_count: zod.number().nullish(),
                                sns_links: zod.array(zod.string().url()).optional(),
                                monthly_rank: zod.number().nullish(),
                                sns_shares: zod.array(zod.string()).optional(),
                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                reviews_count: zod.number().nullish(),
                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                has_user_reviewed: zod.boolean().optional(),
                                review_config: zod
                                    .union([
                                        zod
                                            .object({
                                                review_config_id: zod.number().optional(),
                                                review_config_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemReviewConfigOneReviewConfigNameMax,
                                                    )
                                                    .optional(),
                                                general_description: zod.string().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                        zod.null(),
                                    ])
                                    .optional(),
                                review_questions: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemReviewQuestionsItemQuestionTextThMax,
                                                    )
                                                    .optional(),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemReviewQuestionsItemQuestionTextEnMax,
                                                    )
                                                    .optional(),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemReviewQuestionsItemQuestionTextJaMax,
                                                    )
                                                    .optional(),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional(),
                                                option_th: zod.array(zod.string()).optional(),
                                                option_en: zod.array(zod.string()).optional(),
                                                option_ja: zod.array(zod.string()).optional(),
                                                is_required: zod.number().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                review_data: zod
                                    .union([
                                        zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                answers: zod
                                                    .array(
                                                        zod
                                                            .object({
                                                                review_question_id: zod.number().optional(),
                                                                answer_value: zod.string().optional(),
                                                                question_text_th: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataSnsReviewsItemReviewDataOneAnswersItemQuestionTextThMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_en: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataSnsReviewsItemReviewDataOneAnswersItemQuestionTextEnMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_ja: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataSnsReviewsItemReviewDataOneAnswersItemQuestionTextJaMax,
                                                                    )
                                                                    .optional(),
                                                                question_type: zod.string().optional(),
                                                                option_th: zod.array(zod.string()).optional(),
                                                                option_en: zod.array(zod.string()).optional(),
                                                                option_ja: zod.array(zod.string()).optional(),
                                                                answer_value_th: zod.string().optional(),
                                                                answer_value_en: zod.string().optional(),
                                                                answer_value_ja: zod.string().optional(),
                                                            })
                                                            .strict()
                                                            .describe(
                                                                "Question text\/options\/localized answer values are denormalized onto each answer for display convenience.",
                                                            ),
                                                    )
                                                    .optional(),
                                            })
                                            .strict()
                                            .describe(
                                                "Current user's review data for this post (null if not reviewed)",
                                            ),
                                        zod.null(),
                                    ])
                                    .optional(),
                                ads: zod
                                    .array(
                                        zod
                                            .object({
                                                ad_id: zod.number().optional(),
                                                ad_type: zod
                                                    .enum([
                                                        "PLACE_HOLDER",
                                                        "PRODUCT_LINKER",
                                                        "PRODUCT_LINKER_OGP",
                                                        "PRODUCT_CARD",
                                                        "TOP_BANNER",
                                                        "SECTION_BANNER",
                                                        "USERS_BANNER",
                                                        "USERS_BANNER_RECTANGLE",
                                                        "AUTH_BANNER",
                                                    ])
                                                    .optional(),
                                                image_path: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemAdsItemImagePathMax)
                                                    .optional(),
                                                ad_title: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemAdsItemAdTitleMax)
                                                    .optional(),
                                                ad_body: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemAdsItemAdBodyMax)
                                                    .optional(),
                                                link_url: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemAdsItemLinkUrlMax)
                                                    .optional(),
                                                is_internal_modal_link: zod.boolean().optional(),
                                                modal_board_id: zod.string().nullish(),
                                                modal_post_id: zod.number().nullish(),
                                                ad_product_id: zod.number().nullish(),
                                                display_rate_percent: zod.number().nullish(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Ad item embedded in a home post response"),
                                    )
                                    .optional(),
                                product: zod
                                    .union([
                                        zod
                                            .object({
                                                product_id: zod.number().optional(),
                                                product_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemProductOneProductNameMax,
                                                    )
                                                    .optional(),
                                                product_status: zod
                                                    .enum([
                                                        "draft",
                                                        "editing",
                                                        "released",
                                                        "duplicated",
                                                        "rejected",
                                                        "dummy",
                                                        "brand",
                                                    ])
                                                    .optional(),
                                                brand_id: zod.number().nullish(),
                                                brand_name: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemProductOneBrandNameMax)
                                                    .optional(),
                                                category_id: zod.number().nullish(),
                                                category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemProductOneCategoryNameMax,
                                                    )
                                                    .optional(),
                                                image_url: zod.string().optional(),
                                                image: zod.string().optional(),
                                                review_count: zod.number().nullish(),
                                                average_rating: zod.number().nullish(),
                                                recommend_rank: zod.number().nullish(),
                                                general_description: zod.string().optional(),
                                                product_note: zod.string().optional(),
                                                product_url: zod.string().optional(),
                                                price: zod.number().nullish(),
                                                price_unit: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemProductOnePriceUnitMax)
                                                    .optional(),
                                                group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                                unit: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemProductOneUnitMax)
                                                    .optional(),
                                                how_to_use: zod.string().optional(),
                                                ingredients: zod.string().optional(),
                                                keyword: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataSnsReviewsItemProductOneKeywordMax)
                                                    .optional(),
                                                created_by: zod.number().nullish(),
                                                updated_by: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod.number().nullish(),
                                                parent_category_id: zod.number().nullish(),
                                                parent_category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemProductOneParentCategoryNameMax,
                                                    )
                                                    .optional(),
                                                likes_count: zod.number().nullish(),
                                                comments_count: zod.number().nullish(),
                                                reads_count: zod.number().nullish(),
                                                review_count_guest: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                posts_count_guest: zod.number().nullish(),
                                                positive_points_th: zod.array(zod.string()).optional(),
                                                negative_points_th: zod.array(zod.string()).optional(),
                                                positive_points_en: zod.array(zod.string()).optional(),
                                                negative_points_en: zod.array(zod.string()).optional(),
                                                positive_points_ja: zod.array(zod.string()).optional(),
                                                negative_points_ja: zod.array(zod.string()).optional(),
                                                review_summary_th: zod.string().optional(),
                                                review_summary_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemProductOneReviewSummaryEnMax,
                                                    )
                                                    .optional(),
                                                review_summary_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataSnsReviewsItemProductOneReviewSummaryJaMax,
                                                    )
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Linked product data embedded in a home post response."),
                                        zod.null(),
                                    ])
                                    .optional(),
                                likes: zod
                                    .array(
                                        zod
                                            .object({
                                                like_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                comment_id: zod.number().nullish(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                reads: zod
                                    .array(
                                        zod
                                            .object({
                                                read_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                comments: zod
                                    .array(
                                        zod
                                            .object({
                                                comment_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                content: zod.string().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                board: zod
                                    .object({
                                        board_config_id: zod.number().optional(),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional(),
                                        is_active: zod.number().optional(),
                                        allowed_read_roles: zod.array(zod.string()).optional(),
                                        allowed_write_roles: zod.array(zod.string()).optional(),
                                        allowed_like_roles: zod.array(zod.string()).optional(),
                                        allowed_comment_roles: zod.array(zod.string()).optional(),
                                        comment_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        board_type: zod.enum(["general", "news", "article", "review"]).optional(),
                                        name_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemBoardNameThMax)
                                            .optional(),
                                        name_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemBoardNameEnMax)
                                            .optional(),
                                        name_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemBoardNameJaMax)
                                            .optional(),
                                        description_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemBoardDescriptionThMax)
                                            .optional(),
                                        description_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemBoardDescriptionEnMax)
                                            .optional(),
                                        description_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemBoardDescriptionJaMax)
                                            .optional(),
                                        list_style: zod.enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"]).optional(),
                                        modal_usage: zod
                                            .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                                            .optional(),
                                        modal_size: zod
                                            .enum(["small", "medium", "large", "extra-large", "N/A"])
                                            .optional(),
                                        title_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        fixed_title: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemBoardFixedTitleMax)
                                            .optional(),
                                        product_linker_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        target_product_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        ogp_preview_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        user_info_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        show_content: zod.enum(["SHOW", "HIDE"]).optional(),
                                        rating_overlay_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        date_show: zod.enum(["SHOW", "HIDE"]).nullish(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        review_config_id: zod.number().nullish(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional(),
                                user: zod
                                    .object({
                                        user_id: zod.number(),
                                        display_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserDisplayNameMax)
                                            .optional(),
                                        first_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserFirstNameMax)
                                            .optional(),
                                        last_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserLastNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserNickNameMax)
                                            .optional(),
                                        date_of_birth: zod.string().date().nullish(),
                                        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        skin_concerns: zod.array(zod.string()).optional(),
                                        skin_tone: zod
                                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                            .nullish(),
                                        hair_type: zod
                                            .enum([
                                                "straight_coarse",
                                                "straight_soft",
                                                "wavy_coarse",
                                                "wavy_soft",
                                                "normal_hair",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                        preferred_price_range: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserPreferredPriceRangeMax)
                                            .optional(),
                                        social_instagram: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserSocialInstagramMax)
                                            .optional(),
                                        social_facebook: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserSocialFacebookMax)
                                            .optional(),
                                        social_x: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserSocialXMax)
                                            .optional(),
                                        social_tiktok: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserSocialTiktokMax)
                                            .optional(),
                                        social_youtube: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserSocialYoutubeMax)
                                            .optional(),
                                        social_website: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserSocialWebsiteMax)
                                            .optional(),
                                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        review_count: zod.number().nullish(),
                                        avatar: zod
                                            .string()
                                            .max(getHomeData200ResponseDataSnsReviewsItemUserAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        followings_count: zod.number().optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("User item for home page sections"),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Post item for home page sections"),
                    )
                    .describe(
                        "board_id=tiktoks posts (SNS reviews), site-wide — recommended ones first (recommend_rank), then the rest in random order — same section as \/brands\/{id}",
                    ),
                ranking_products: zod
                    .object({
                        parent_categories: zod
                            .array(
                                zod
                                    .object({
                                        category_id: zod.number().nullable(),
                                        label: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRankingProductsParentCategoriesItemLabelMax),
                                    })
                                    .strict()
                                    .describe("Parent category entry for product ranking tabs"),
                            )
                            .describe("List of parent categories with products in the ranking"),
                        initial_parent_category_id: zod
                            .number()
                            .nullish()
                            .describe("Default selected parent category ID for the ranking tab"),
                        rankings_by_parent: zod
                            .record(
                                zod.string(),
                                zod.array(
                                    zod
                                        .object({
                                            product_id: zod.number(),
                                            product_status: zod
                                                .enum([
                                                    "draft",
                                                    "editing",
                                                    "released",
                                                    "duplicated",
                                                    "rejected",
                                                    "dummy",
                                                    "brand",
                                                ])
                                                .optional(),
                                            product_name: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneProductNameMax,
                                                ),
                                            product_url: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneProductUrlMax,
                                                )
                                                .optional(),
                                            image: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneImageMax,
                                                )
                                                .optional(),
                                            category_id: zod.number().nullish(),
                                            brand_id: zod.number().nullish(),
                                            brand_name: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneBrandNameMax,
                                                )
                                                .optional(),
                                            average_rating: zod.number().nullish(),
                                            review_count: zod.number().nullish(),
                                            recommend_rank: zod.number().min(1).nullish(),
                                            product_note: zod.string().optional(),
                                            price: zod.number().nullish(),
                                            price_unit: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOnePriceUnitMax,
                                                )
                                                .optional(),
                                            group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                            unit: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneUnitMax,
                                                )
                                                .optional(),
                                            how_to_use: zod.string().optional(),
                                            ingredients: zod.string().optional(),
                                            review_count_guest: zod.number().nullish(),
                                            posts_count: zod.number().nullish(),
                                            posts_count_guest: zod.number().nullish(),
                                            likes_count: zod.number().nullish(),
                                            comments_count: zod.number().nullish(),
                                            reads_count: zod.number().nullish(),
                                            general_description: zod.string().optional(),
                                            keyword: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneKeywordMax,
                                                )
                                                .optional(),
                                            created_by: zod.number().nullish(),
                                            updated_by: zod.number().nullish(),
                                            monthly_rank: zod
                                                .number()
                                                .min(1)
                                                .nullish()
                                                .describe("Monthly ranking position"),
                                            manual_score_offset: zod.number().nullish(),
                                            parent_category_id: zod.number().nullish(),
                                            parent_category_name: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneParentCategoryNameMax,
                                                )
                                                .optional(),
                                            category_name: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryNameMax,
                                                )
                                                .optional(),
                                            positive_points_th: zod.array(zod.string()).optional(),
                                            negative_points_th: zod.array(zod.string()).optional(),
                                            positive_points_en: zod.array(zod.string()).optional(),
                                            negative_points_en: zod.array(zod.string()).optional(),
                                            positive_points_ja: zod.array(zod.string()).optional(),
                                            negative_points_ja: zod.array(zod.string()).optional(),
                                            review_summary_th: zod.string().optional(),
                                            review_summary_en: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneReviewSummaryEnMax,
                                                )
                                                .optional(),
                                            review_summary_ja: zod
                                                .string()
                                                .max(
                                                    getHomeData200ResponseDataRankingProductsRankingsByParentItemOneReviewSummaryJaMax,
                                                )
                                                .optional(),
                                            likes: zod
                                                .array(
                                                    zod
                                                        .object({
                                                            like_id: zod.number().optional(),
                                                            post_id: zod.number().optional(),
                                                            comment_id: zod.number().nullish(),
                                                            user_id: zod.number().optional(),
                                                            created_at: zod
                                                                .string()
                                                                .datetime({ offset: true })
                                                                .optional(),
                                                            updated_at: zod
                                                                .string()
                                                                .datetime({ offset: true })
                                                                .optional(),
                                                        })
                                                        .strict(),
                                                )
                                                .optional(),
                                            comments: zod
                                                .array(
                                                    zod
                                                        .object({
                                                            comment_id: zod.number().optional(),
                                                            post_id: zod.number().optional(),
                                                            user_id: zod.number().optional(),
                                                            content: zod.string().optional(),
                                                            created_at: zod
                                                                .string()
                                                                .datetime({ offset: true })
                                                                .optional(),
                                                        })
                                                        .strict(),
                                                )
                                                .optional(),
                                            likes_by_post: zod
                                                .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                                .optional()
                                                .describe("Likes grouped by post ID for list\/detail convenience"),
                                            comments_by_post: zod
                                                .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                                .optional()
                                                .describe("Comments grouped by post ID for list\/detail convenience"),
                                            image_url: zod.string().optional(),
                                            rank: zod.number().optional(),
                                            category: zod
                                                .object({
                                                    category_id: zod.number().nullish(),
                                                    category_name: zod
                                                        .string()
                                                        .max(
                                                            getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryCategoryNameMax,
                                                        )
                                                        .optional(),
                                                    category_icon: zod
                                                        .string()
                                                        .max(
                                                            getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryCategoryIconMax,
                                                        )
                                                        .optional(),
                                                    parent_category_id: zod.number().nullish(),
                                                    parent_category_name: zod
                                                        .string()
                                                        .max(
                                                            getHomeData200ResponseDataRankingProductsRankingsByParentItemOneCategoryParentCategoryNameMax,
                                                        )
                                                        .optional(),
                                                    display_order: zod.number().optional(),
                                                    review_config_id: zod.number().optional(),
                                                    products_count: zod.number().optional(),
                                                    is_active: zod.number().optional(),
                                                    created_at: zod.string().datetime({ offset: true }).optional(),
                                                    updated_at: zod.string().datetime({ offset: true }).optional(),
                                                })
                                                .strict()
                                                .nullish(),
                                            brand: zod
                                                .object({
                                                    brand_id: zod.number().nullish(),
                                                    brand_name: zod
                                                        .string()
                                                        .max(
                                                            getHomeData200ResponseDataRankingProductsRankingsByParentItemOneBrandBrandNameMax,
                                                        )
                                                        .optional(),
                                                })
                                                .strict()
                                                .nullish(),
                                            created_at: zod.string().datetime({ offset: true }).optional(),
                                            updated_at: zod.string().datetime({ offset: true }).optional(),
                                        })
                                        .strict(),
                                ),
                            )
                            .describe("Ranked products keyed by parent_category_id (string)"),
                    })
                    .strict()
                    .describe("Product ranking data grouped by parent category"),
                ranking_users: zod
                    .array(
                        zod
                            .object({
                                user_id: zod.number(),
                                display_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneDisplayNameMax)
                                    .optional(),
                                first_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneFirstNameMax)
                                    .optional(),
                                last_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneLastNameMax)
                                    .optional(),
                                nick_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneNickNameMax)
                                    .optional(),
                                date_of_birth: zod.string().date().nullish(),
                                gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                skin_type: zod
                                    .enum([
                                        "normal",
                                        "oily",
                                        "dry",
                                        "combination",
                                        "sensitive",
                                        "dehydrated_oily",
                                        "not_sure",
                                    ])
                                    .nullish(),
                                skin_concerns: zod.array(zod.string()).optional(),
                                skin_tone: zod
                                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                    .nullish(),
                                hair_type: zod
                                    .enum([
                                        "straight_coarse",
                                        "straight_soft",
                                        "wavy_coarse",
                                        "wavy_soft",
                                        "normal_hair",
                                        "not_sure",
                                    ])
                                    .nullish(),
                                hair_scalp_concerns: zod.array(zod.string()).optional(),
                                beauty_wellness_interests: zod.array(zod.string()).optional(),
                                lifestyle_environment: zod.array(zod.string()).optional(),
                                makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                preferred_price_range: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOnePreferredPriceRangeMax)
                                    .optional(),
                                social_instagram: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneSocialInstagramMax)
                                    .optional(),
                                social_facebook: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneSocialFacebookMax)
                                    .optional(),
                                social_x: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneSocialXMax)
                                    .optional(),
                                social_tiktok: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneSocialTiktokMax)
                                    .optional(),
                                social_youtube: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneSocialYoutubeMax)
                                    .optional(),
                                social_website: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneSocialWebsiteMax)
                                    .optional(),
                                role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                recommend_rank: zod.number().nullish(),
                                review_count: zod.number().nullish(),
                                avatar: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRankingUsersItemOneAvatarMax)
                                    .optional(),
                                posts_count: zod.number().nullish(),
                                followers_count: zod.number().optional(),
                                followings_count: zod.number().optional(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                monthly_rank: zod.number().min(1).nullish().describe("Monthly ranking position"),
                                rank: zod.number().min(1).optional().describe("Alias of monthly_rank for display"),
                                age_range_low: zod.number().nullish(),
                                age_range_high: zod.number().nullish(),
                                point: zod.number().optional(),
                            })
                            .strict(),
                    )
                    .describe("Monthly top-ranked users"),
                review_awards: zod
                    .array(
                        zod
                            .object({
                                product_id: zod.number(),
                                product_status: zod
                                    .enum(["draft", "editing", "released", "duplicated", "rejected", "dummy", "brand"])
                                    .optional(),
                                product_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemProductNameMax),
                                product_url: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemProductUrlMax)
                                    .optional(),
                                image: zod.string().max(getHomeData200ResponseDataReviewAwardsItemImageMax).optional(),
                                category_id: zod.number().nullish(),
                                brand_id: zod.number().nullish(),
                                brand_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemBrandNameMax)
                                    .optional(),
                                average_rating: zod.number().nullish(),
                                review_count: zod.number().nullish(),
                                recommend_rank: zod.number().min(1).nullish(),
                                product_note: zod.string().optional(),
                                price: zod.number().nullish(),
                                price_unit: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemPriceUnitMax)
                                    .optional(),
                                group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                unit: zod.string().max(getHomeData200ResponseDataReviewAwardsItemUnitMax).optional(),
                                how_to_use: zod.string().optional(),
                                ingredients: zod.string().optional(),
                                review_count_guest: zod.number().nullish(),
                                posts_count: zod.number().nullish(),
                                posts_count_guest: zod.number().nullish(),
                                likes_count: zod.number().nullish(),
                                comments_count: zod.number().nullish(),
                                reads_count: zod.number().nullish(),
                                general_description: zod.string().optional(),
                                keyword: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemKeywordMax)
                                    .optional(),
                                created_by: zod.number().nullish(),
                                updated_by: zod.number().nullish(),
                                monthly_rank: zod.number().nullish(),
                                manual_score_offset: zod.number().nullish(),
                                parent_category_id: zod.number().nullish(),
                                parent_category_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemParentCategoryNameMax)
                                    .optional(),
                                category_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemCategoryNameMax)
                                    .optional(),
                                positive_points_th: zod.array(zod.string()).optional(),
                                negative_points_th: zod.array(zod.string()).optional(),
                                positive_points_en: zod.array(zod.string()).optional(),
                                negative_points_en: zod.array(zod.string()).optional(),
                                positive_points_ja: zod.array(zod.string()).optional(),
                                negative_points_ja: zod.array(zod.string()).optional(),
                                review_summary_th: zod.string().optional(),
                                review_summary_en: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemReviewSummaryEnMax)
                                    .optional(),
                                review_summary_ja: zod
                                    .string()
                                    .max(getHomeData200ResponseDataReviewAwardsItemReviewSummaryJaMax)
                                    .optional(),
                                likes: zod
                                    .array(
                                        zod
                                            .object({
                                                like_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                comment_id: zod.number().nullish(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                comments: zod
                                    .array(
                                        zod
                                            .object({
                                                comment_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                content: zod.string().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                likes_by_post: zod
                                    .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                    .optional()
                                    .describe("Likes grouped by post ID for list\/detail convenience"),
                                comments_by_post: zod
                                    .record(zod.string(), zod.array(zod.object({}).passthrough()))
                                    .optional()
                                    .describe("Comments grouped by post ID for list\/detail convenience"),
                                image_url: zod.string().optional(),
                                rank: zod.number().optional(),
                                category: zod
                                    .object({
                                        category_id: zod.number().nullish(),
                                        category_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataReviewAwardsItemCategoryCategoryNameMax)
                                            .optional(),
                                        category_icon: zod
                                            .string()
                                            .max(getHomeData200ResponseDataReviewAwardsItemCategoryCategoryIconMax)
                                            .optional(),
                                        parent_category_id: zod.number().nullish(),
                                        parent_category_name: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataReviewAwardsItemCategoryParentCategoryNameMax,
                                            )
                                            .optional(),
                                        display_order: zod.number().optional(),
                                        review_config_id: zod.number().optional(),
                                        products_count: zod.number().optional(),
                                        is_active: zod.number().optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .nullish(),
                                brand: zod
                                    .object({
                                        brand_id: zod.number().nullish(),
                                        brand_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataReviewAwardsItemBrandBrandNameMax)
                                            .optional(),
                                    })
                                    .strict()
                                    .nullish(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Product item for home page sections"),
                    )
                    .describe("Recommended products sorted by recommend_rank asc (displayed as product cards)"),
                recommend_reviews: zod
                    .array(
                        zod
                            .object({
                                post_id: zod.number(),
                                board_id: zod.enum([
                                    "review",
                                    "tiktoks",
                                    "beauty_news",
                                    "editorial_reviews",
                                    "expert_reviews",
                                    "activities",
                                    "test_modal",
                                    "test_modeless",
                                    "guidance",
                                ]),
                                user_id: zod.number(),
                                post_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendReviewsItemPostTitleMax)
                                    .optional(),
                                content: zod.string().optional(),
                                post_product_id: zod.number().nullish(),
                                product_brand_name: zod.string().nullish(),
                                product_category_id: zod.number().nullish(),
                                product_category_name: zod.string().nullish(),
                                product_parent_category_id: zod.number().nullish(),
                                product_parent_category_name: zod.string().nullish(),
                                recommend_rank: zod.number().min(1).nullish(),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Average review rating (review-board posts only), derived from the post's rating answers. null when the post has no rating answers or is not a review post.\n",
                                    ),
                                attached_images: zod.array(zod.string()).optional(),
                                likes_count: zod.number().nullish(),
                                reads_count: zod.number().nullish(),
                                attached_videos: zod.array(zod.string()).optional(),
                                content_images: zod.array(zod.string()).optional(),
                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                comments_count: zod.number().nullish(),
                                sns_links: zod.array(zod.string().url()).optional(),
                                monthly_rank: zod.number().nullish(),
                                sns_shares: zod.array(zod.string()).optional(),
                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                reviews_count: zod.number().nullish(),
                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                has_user_reviewed: zod.boolean().optional(),
                                review_config: zod
                                    .union([
                                        zod
                                            .object({
                                                review_config_id: zod.number().optional(),
                                                review_config_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemReviewConfigOneReviewConfigNameMax,
                                                    )
                                                    .optional(),
                                                general_description: zod.string().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                        zod.null(),
                                    ])
                                    .optional(),
                                review_questions: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemReviewQuestionsItemQuestionTextThMax,
                                                    )
                                                    .optional(),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemReviewQuestionsItemQuestionTextEnMax,
                                                    )
                                                    .optional(),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemReviewQuestionsItemQuestionTextJaMax,
                                                    )
                                                    .optional(),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional(),
                                                option_th: zod.array(zod.string()).optional(),
                                                option_en: zod.array(zod.string()).optional(),
                                                option_ja: zod.array(zod.string()).optional(),
                                                is_required: zod.number().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                review_data: zod
                                    .union([
                                        zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                answers: zod
                                                    .array(
                                                        zod
                                                            .object({
                                                                review_question_id: zod.number().optional(),
                                                                answer_value: zod.string().optional(),
                                                                question_text_th: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataRecommendReviewsItemReviewDataOneAnswersItemQuestionTextThMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_en: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataRecommendReviewsItemReviewDataOneAnswersItemQuestionTextEnMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_ja: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataRecommendReviewsItemReviewDataOneAnswersItemQuestionTextJaMax,
                                                                    )
                                                                    .optional(),
                                                                question_type: zod.string().optional(),
                                                                option_th: zod.array(zod.string()).optional(),
                                                                option_en: zod.array(zod.string()).optional(),
                                                                option_ja: zod.array(zod.string()).optional(),
                                                                answer_value_th: zod.string().optional(),
                                                                answer_value_en: zod.string().optional(),
                                                                answer_value_ja: zod.string().optional(),
                                                            })
                                                            .strict()
                                                            .describe(
                                                                "Question text\/options\/localized answer values are denormalized onto each answer for display convenience.",
                                                            ),
                                                    )
                                                    .optional(),
                                            })
                                            .strict()
                                            .describe(
                                                "Current user's review data for this post (null if not reviewed)",
                                            ),
                                        zod.null(),
                                    ])
                                    .optional(),
                                ads: zod
                                    .array(
                                        zod
                                            .object({
                                                ad_id: zod.number().optional(),
                                                ad_type: zod
                                                    .enum([
                                                        "PLACE_HOLDER",
                                                        "PRODUCT_LINKER",
                                                        "PRODUCT_LINKER_OGP",
                                                        "PRODUCT_CARD",
                                                        "TOP_BANNER",
                                                        "SECTION_BANNER",
                                                        "USERS_BANNER",
                                                        "USERS_BANNER_RECTANGLE",
                                                        "AUTH_BANNER",
                                                    ])
                                                    .optional(),
                                                image_path: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemAdsItemImagePathMax,
                                                    )
                                                    .optional(),
                                                ad_title: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemAdsItemAdTitleMax,
                                                    )
                                                    .optional(),
                                                ad_body: zod
                                                    .string()
                                                    .max(getHomeData200ResponseDataRecommendReviewsItemAdsItemAdBodyMax)
                                                    .optional(),
                                                link_url: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemAdsItemLinkUrlMax,
                                                    )
                                                    .optional(),
                                                is_internal_modal_link: zod.boolean().optional(),
                                                modal_board_id: zod.string().nullish(),
                                                modal_post_id: zod.number().nullish(),
                                                ad_product_id: zod.number().nullish(),
                                                display_rate_percent: zod.number().nullish(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Ad item embedded in a home post response"),
                                    )
                                    .optional(),
                                product: zod
                                    .union([
                                        zod
                                            .object({
                                                product_id: zod.number().optional(),
                                                product_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneProductNameMax,
                                                    )
                                                    .optional(),
                                                product_status: zod
                                                    .enum([
                                                        "draft",
                                                        "editing",
                                                        "released",
                                                        "duplicated",
                                                        "rejected",
                                                        "dummy",
                                                        "brand",
                                                    ])
                                                    .optional(),
                                                brand_id: zod.number().nullish(),
                                                brand_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneBrandNameMax,
                                                    )
                                                    .optional(),
                                                category_id: zod.number().nullish(),
                                                category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneCategoryNameMax,
                                                    )
                                                    .optional(),
                                                image_url: zod.string().optional(),
                                                image: zod.string().optional(),
                                                review_count: zod.number().nullish(),
                                                average_rating: zod.number().nullish(),
                                                recommend_rank: zod.number().nullish(),
                                                general_description: zod.string().optional(),
                                                product_note: zod.string().optional(),
                                                product_url: zod.string().optional(),
                                                price: zod.number().nullish(),
                                                price_unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOnePriceUnitMax,
                                                    )
                                                    .optional(),
                                                group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                                unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneUnitMax,
                                                    )
                                                    .optional(),
                                                how_to_use: zod.string().optional(),
                                                ingredients: zod.string().optional(),
                                                keyword: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneKeywordMax,
                                                    )
                                                    .optional(),
                                                created_by: zod.number().nullish(),
                                                updated_by: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod.number().nullish(),
                                                parent_category_id: zod.number().nullish(),
                                                parent_category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneParentCategoryNameMax,
                                                    )
                                                    .optional(),
                                                likes_count: zod.number().nullish(),
                                                comments_count: zod.number().nullish(),
                                                reads_count: zod.number().nullish(),
                                                review_count_guest: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                posts_count_guest: zod.number().nullish(),
                                                positive_points_th: zod.array(zod.string()).optional(),
                                                negative_points_th: zod.array(zod.string()).optional(),
                                                positive_points_en: zod.array(zod.string()).optional(),
                                                negative_points_en: zod.array(zod.string()).optional(),
                                                positive_points_ja: zod.array(zod.string()).optional(),
                                                negative_points_ja: zod.array(zod.string()).optional(),
                                                review_summary_th: zod.string().optional(),
                                                review_summary_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneReviewSummaryEnMax,
                                                    )
                                                    .optional(),
                                                review_summary_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataRecommendReviewsItemProductOneReviewSummaryJaMax,
                                                    )
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Linked product data embedded in a home post response."),
                                        zod.null(),
                                    ])
                                    .optional(),
                                likes: zod
                                    .array(
                                        zod
                                            .object({
                                                like_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                comment_id: zod.number().nullish(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                reads: zod
                                    .array(
                                        zod
                                            .object({
                                                read_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                comments: zod
                                    .array(
                                        zod
                                            .object({
                                                comment_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                content: zod.string().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                board: zod
                                    .object({
                                        board_config_id: zod.number().optional(),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional(),
                                        is_active: zod.number().optional(),
                                        allowed_read_roles: zod.array(zod.string()).optional(),
                                        allowed_write_roles: zod.array(zod.string()).optional(),
                                        allowed_like_roles: zod.array(zod.string()).optional(),
                                        allowed_comment_roles: zod.array(zod.string()).optional(),
                                        comment_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        board_type: zod.enum(["general", "news", "article", "review"]).optional(),
                                        name_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemBoardNameThMax)
                                            .optional(),
                                        name_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemBoardNameEnMax)
                                            .optional(),
                                        name_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemBoardNameJaMax)
                                            .optional(),
                                        description_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemBoardDescriptionThMax)
                                            .optional(),
                                        description_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemBoardDescriptionEnMax)
                                            .optional(),
                                        description_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemBoardDescriptionJaMax)
                                            .optional(),
                                        list_style: zod.enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"]).optional(),
                                        modal_usage: zod
                                            .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                                            .optional(),
                                        modal_size: zod
                                            .enum(["small", "medium", "large", "extra-large", "N/A"])
                                            .optional(),
                                        title_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        fixed_title: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemBoardFixedTitleMax)
                                            .optional(),
                                        product_linker_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        target_product_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        ogp_preview_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        user_info_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        show_content: zod.enum(["SHOW", "HIDE"]).optional(),
                                        rating_overlay_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        date_show: zod.enum(["SHOW", "HIDE"]).nullish(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        review_config_id: zod.number().nullish(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional(),
                                user: zod
                                    .object({
                                        user_id: zod.number(),
                                        display_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserDisplayNameMax)
                                            .optional(),
                                        first_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserFirstNameMax)
                                            .optional(),
                                        last_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserLastNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserNickNameMax)
                                            .optional(),
                                        date_of_birth: zod.string().date().nullish(),
                                        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        skin_concerns: zod.array(zod.string()).optional(),
                                        skin_tone: zod
                                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                            .nullish(),
                                        hair_type: zod
                                            .enum([
                                                "straight_coarse",
                                                "straight_soft",
                                                "wavy_coarse",
                                                "wavy_soft",
                                                "normal_hair",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                        preferred_price_range: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataRecommendReviewsItemUserPreferredPriceRangeMax,
                                            )
                                            .optional(),
                                        social_instagram: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserSocialInstagramMax)
                                            .optional(),
                                        social_facebook: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserSocialFacebookMax)
                                            .optional(),
                                        social_x: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserSocialXMax)
                                            .optional(),
                                        social_tiktok: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserSocialTiktokMax)
                                            .optional(),
                                        social_youtube: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserSocialYoutubeMax)
                                            .optional(),
                                        social_website: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserSocialWebsiteMax)
                                            .optional(),
                                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        review_count: zod.number().nullish(),
                                        avatar: zod
                                            .string()
                                            .max(getHomeData200ResponseDataRecommendReviewsItemUserAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        followings_count: zod.number().optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("User item for home page sections"),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Post item for home page sections"),
                    )
                    .describe("Recommended review posts sorted by recommend_rank asc"),
                recommend_users: zod
                    .array(
                        zod
                            .object({
                                user_id: zod.number(),
                                display_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemDisplayNameMax)
                                    .optional(),
                                first_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemFirstNameMax)
                                    .optional(),
                                last_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemLastNameMax)
                                    .optional(),
                                nick_name: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemNickNameMax)
                                    .optional(),
                                date_of_birth: zod.string().date().nullish(),
                                gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                skin_type: zod
                                    .enum([
                                        "normal",
                                        "oily",
                                        "dry",
                                        "combination",
                                        "sensitive",
                                        "dehydrated_oily",
                                        "not_sure",
                                    ])
                                    .nullish(),
                                skin_concerns: zod.array(zod.string()).optional(),
                                skin_tone: zod
                                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                    .nullish(),
                                hair_type: zod
                                    .enum([
                                        "straight_coarse",
                                        "straight_soft",
                                        "wavy_coarse",
                                        "wavy_soft",
                                        "normal_hair",
                                        "not_sure",
                                    ])
                                    .nullish(),
                                hair_scalp_concerns: zod.array(zod.string()).optional(),
                                beauty_wellness_interests: zod.array(zod.string()).optional(),
                                lifestyle_environment: zod.array(zod.string()).optional(),
                                makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                preferred_price_range: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemPreferredPriceRangeMax)
                                    .optional(),
                                social_instagram: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemSocialInstagramMax)
                                    .optional(),
                                social_facebook: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemSocialFacebookMax)
                                    .optional(),
                                social_x: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemSocialXMax)
                                    .optional(),
                                social_tiktok: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemSocialTiktokMax)
                                    .optional(),
                                social_youtube: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemSocialYoutubeMax)
                                    .optional(),
                                social_website: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemSocialWebsiteMax)
                                    .optional(),
                                role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                recommend_rank: zod.number().nullish(),
                                review_count: zod.number().nullish(),
                                avatar: zod
                                    .string()
                                    .max(getHomeData200ResponseDataRecommendUsersItemAvatarMax)
                                    .optional(),
                                posts_count: zod.number().nullish(),
                                followers_count: zod.number().optional(),
                                followings_count: zod.number().optional(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("User item for home page sections"),
                    )
                    .describe("Recommended users"),
                articles_beauty_news: zod
                    .array(
                        zod
                            .object({
                                post_id: zod.number(),
                                board_id: zod.enum([
                                    "review",
                                    "tiktoks",
                                    "beauty_news",
                                    "editorial_reviews",
                                    "expert_reviews",
                                    "activities",
                                    "test_modal",
                                    "test_modeless",
                                    "guidance",
                                ]),
                                user_id: zod.number(),
                                post_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataArticlesBeautyNewsItemPostTitleMax)
                                    .optional(),
                                content: zod.string().optional(),
                                post_product_id: zod.number().nullish(),
                                product_brand_name: zod.string().nullish(),
                                product_category_id: zod.number().nullish(),
                                product_category_name: zod.string().nullish(),
                                product_parent_category_id: zod.number().nullish(),
                                product_parent_category_name: zod.string().nullish(),
                                recommend_rank: zod.number().min(1).nullish(),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Average review rating (review-board posts only), derived from the post's rating answers. null when the post has no rating answers or is not a review post.\n",
                                    ),
                                attached_images: zod.array(zod.string()).optional(),
                                likes_count: zod.number().nullish(),
                                reads_count: zod.number().nullish(),
                                attached_videos: zod.array(zod.string()).optional(),
                                content_images: zod.array(zod.string()).optional(),
                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                comments_count: zod.number().nullish(),
                                sns_links: zod.array(zod.string().url()).optional(),
                                monthly_rank: zod.number().nullish(),
                                sns_shares: zod.array(zod.string()).optional(),
                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                reviews_count: zod.number().nullish(),
                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                has_user_reviewed: zod.boolean().optional(),
                                review_config: zod
                                    .union([
                                        zod
                                            .object({
                                                review_config_id: zod.number().optional(),
                                                review_config_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemReviewConfigOneReviewConfigNameMax,
                                                    )
                                                    .optional(),
                                                general_description: zod.string().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                        zod.null(),
                                    ])
                                    .optional(),
                                review_questions: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemReviewQuestionsItemQuestionTextThMax,
                                                    )
                                                    .optional(),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemReviewQuestionsItemQuestionTextEnMax,
                                                    )
                                                    .optional(),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemReviewQuestionsItemQuestionTextJaMax,
                                                    )
                                                    .optional(),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional(),
                                                option_th: zod.array(zod.string()).optional(),
                                                option_en: zod.array(zod.string()).optional(),
                                                option_ja: zod.array(zod.string()).optional(),
                                                is_required: zod.number().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                review_data: zod
                                    .union([
                                        zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                answers: zod
                                                    .array(
                                                        zod
                                                            .object({
                                                                review_question_id: zod.number().optional(),
                                                                answer_value: zod.string().optional(),
                                                                question_text_th: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesBeautyNewsItemReviewDataOneAnswersItemQuestionTextThMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_en: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesBeautyNewsItemReviewDataOneAnswersItemQuestionTextEnMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_ja: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesBeautyNewsItemReviewDataOneAnswersItemQuestionTextJaMax,
                                                                    )
                                                                    .optional(),
                                                                question_type: zod.string().optional(),
                                                                option_th: zod.array(zod.string()).optional(),
                                                                option_en: zod.array(zod.string()).optional(),
                                                                option_ja: zod.array(zod.string()).optional(),
                                                                answer_value_th: zod.string().optional(),
                                                                answer_value_en: zod.string().optional(),
                                                                answer_value_ja: zod.string().optional(),
                                                            })
                                                            .strict()
                                                            .describe(
                                                                "Question text\/options\/localized answer values are denormalized onto each answer for display convenience.",
                                                            ),
                                                    )
                                                    .optional(),
                                            })
                                            .strict()
                                            .describe(
                                                "Current user's review data for this post (null if not reviewed)",
                                            ),
                                        zod.null(),
                                    ])
                                    .optional(),
                                ads: zod
                                    .array(
                                        zod
                                            .object({
                                                ad_id: zod.number().optional(),
                                                ad_type: zod
                                                    .enum([
                                                        "PLACE_HOLDER",
                                                        "PRODUCT_LINKER",
                                                        "PRODUCT_LINKER_OGP",
                                                        "PRODUCT_CARD",
                                                        "TOP_BANNER",
                                                        "SECTION_BANNER",
                                                        "USERS_BANNER",
                                                        "USERS_BANNER_RECTANGLE",
                                                        "AUTH_BANNER",
                                                    ])
                                                    .optional(),
                                                image_path: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemImagePathMax,
                                                    )
                                                    .optional(),
                                                ad_title: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemAdTitleMax,
                                                    )
                                                    .optional(),
                                                ad_body: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemAdBodyMax,
                                                    )
                                                    .optional(),
                                                link_url: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemAdsItemLinkUrlMax,
                                                    )
                                                    .optional(),
                                                is_internal_modal_link: zod.boolean().optional(),
                                                modal_board_id: zod.string().nullish(),
                                                modal_post_id: zod.number().nullish(),
                                                ad_product_id: zod.number().nullish(),
                                                display_rate_percent: zod.number().nullish(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Ad item embedded in a home post response"),
                                    )
                                    .optional(),
                                product: zod
                                    .union([
                                        zod
                                            .object({
                                                product_id: zod.number().optional(),
                                                product_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneProductNameMax,
                                                    )
                                                    .optional(),
                                                product_status: zod
                                                    .enum([
                                                        "draft",
                                                        "editing",
                                                        "released",
                                                        "duplicated",
                                                        "rejected",
                                                        "dummy",
                                                        "brand",
                                                    ])
                                                    .optional(),
                                                brand_id: zod.number().nullish(),
                                                brand_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneBrandNameMax,
                                                    )
                                                    .optional(),
                                                category_id: zod.number().nullish(),
                                                category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneCategoryNameMax,
                                                    )
                                                    .optional(),
                                                image_url: zod.string().optional(),
                                                image: zod.string().optional(),
                                                review_count: zod.number().nullish(),
                                                average_rating: zod.number().nullish(),
                                                recommend_rank: zod.number().nullish(),
                                                general_description: zod.string().optional(),
                                                product_note: zod.string().optional(),
                                                product_url: zod.string().optional(),
                                                price: zod.number().nullish(),
                                                price_unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOnePriceUnitMax,
                                                    )
                                                    .optional(),
                                                group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                                unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneUnitMax,
                                                    )
                                                    .optional(),
                                                how_to_use: zod.string().optional(),
                                                ingredients: zod.string().optional(),
                                                keyword: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneKeywordMax,
                                                    )
                                                    .optional(),
                                                created_by: zod.number().nullish(),
                                                updated_by: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod.number().nullish(),
                                                parent_category_id: zod.number().nullish(),
                                                parent_category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneParentCategoryNameMax,
                                                    )
                                                    .optional(),
                                                likes_count: zod.number().nullish(),
                                                comments_count: zod.number().nullish(),
                                                reads_count: zod.number().nullish(),
                                                review_count_guest: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                posts_count_guest: zod.number().nullish(),
                                                positive_points_th: zod.array(zod.string()).optional(),
                                                negative_points_th: zod.array(zod.string()).optional(),
                                                positive_points_en: zod.array(zod.string()).optional(),
                                                negative_points_en: zod.array(zod.string()).optional(),
                                                positive_points_ja: zod.array(zod.string()).optional(),
                                                negative_points_ja: zod.array(zod.string()).optional(),
                                                review_summary_th: zod.string().optional(),
                                                review_summary_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneReviewSummaryEnMax,
                                                    )
                                                    .optional(),
                                                review_summary_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesBeautyNewsItemProductOneReviewSummaryJaMax,
                                                    )
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Linked product data embedded in a home post response."),
                                        zod.null(),
                                    ])
                                    .optional(),
                                likes: zod
                                    .array(
                                        zod
                                            .object({
                                                like_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                comment_id: zod.number().nullish(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                reads: zod
                                    .array(
                                        zod
                                            .object({
                                                read_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                comments: zod
                                    .array(
                                        zod
                                            .object({
                                                comment_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                content: zod.string().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                board: zod
                                    .object({
                                        board_config_id: zod.number().optional(),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional(),
                                        is_active: zod.number().optional(),
                                        allowed_read_roles: zod.array(zod.string()).optional(),
                                        allowed_write_roles: zod.array(zod.string()).optional(),
                                        allowed_like_roles: zod.array(zod.string()).optional(),
                                        allowed_comment_roles: zod.array(zod.string()).optional(),
                                        comment_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        board_type: zod.enum(["general", "news", "article", "review"]).optional(),
                                        name_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemBoardNameThMax)
                                            .optional(),
                                        name_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemBoardNameEnMax)
                                            .optional(),
                                        name_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemBoardNameJaMax)
                                            .optional(),
                                        description_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemBoardDescriptionThMax)
                                            .optional(),
                                        description_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemBoardDescriptionEnMax)
                                            .optional(),
                                        description_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemBoardDescriptionJaMax)
                                            .optional(),
                                        list_style: zod.enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"]).optional(),
                                        modal_usage: zod
                                            .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                                            .optional(),
                                        modal_size: zod
                                            .enum(["small", "medium", "large", "extra-large", "N/A"])
                                            .optional(),
                                        title_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        fixed_title: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemBoardFixedTitleMax)
                                            .optional(),
                                        product_linker_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        target_product_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        ogp_preview_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        user_info_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        show_content: zod.enum(["SHOW", "HIDE"]).optional(),
                                        rating_overlay_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        date_show: zod.enum(["SHOW", "HIDE"]).nullish(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        review_config_id: zod.number().nullish(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional(),
                                user: zod
                                    .object({
                                        user_id: zod.number(),
                                        display_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserDisplayNameMax)
                                            .optional(),
                                        first_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserFirstNameMax)
                                            .optional(),
                                        last_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserLastNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserNickNameMax)
                                            .optional(),
                                        date_of_birth: zod.string().date().nullish(),
                                        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        skin_concerns: zod.array(zod.string()).optional(),
                                        skin_tone: zod
                                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                            .nullish(),
                                        hair_type: zod
                                            .enum([
                                                "straight_coarse",
                                                "straight_soft",
                                                "wavy_coarse",
                                                "wavy_soft",
                                                "normal_hair",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                        preferred_price_range: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesBeautyNewsItemUserPreferredPriceRangeMax,
                                            )
                                            .optional(),
                                        social_instagram: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialInstagramMax)
                                            .optional(),
                                        social_facebook: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialFacebookMax)
                                            .optional(),
                                        social_x: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialXMax)
                                            .optional(),
                                        social_tiktok: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialTiktokMax)
                                            .optional(),
                                        social_youtube: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialYoutubeMax)
                                            .optional(),
                                        social_website: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserSocialWebsiteMax)
                                            .optional(),
                                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        review_count: zod.number().nullish(),
                                        avatar: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesBeautyNewsItemUserAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        followings_count: zod.number().optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("User item for home page sections"),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Post item for home page sections"),
                    )
                    .describe("Latest beauty_news board articles"),
                articles_editorial_reviews: zod
                    .array(
                        zod
                            .object({
                                post_id: zod.number(),
                                board_id: zod.enum([
                                    "review",
                                    "tiktoks",
                                    "beauty_news",
                                    "editorial_reviews",
                                    "expert_reviews",
                                    "activities",
                                    "test_modal",
                                    "test_modeless",
                                    "guidance",
                                ]),
                                user_id: zod.number(),
                                post_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataArticlesEditorialReviewsItemPostTitleMax)
                                    .optional(),
                                content: zod.string().optional(),
                                post_product_id: zod.number().nullish(),
                                product_brand_name: zod.string().nullish(),
                                product_category_id: zod.number().nullish(),
                                product_category_name: zod.string().nullish(),
                                product_parent_category_id: zod.number().nullish(),
                                product_parent_category_name: zod.string().nullish(),
                                recommend_rank: zod.number().min(1).nullish(),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Average review rating (review-board posts only), derived from the post's rating answers. null when the post has no rating answers or is not a review post.\n",
                                    ),
                                attached_images: zod.array(zod.string()).optional(),
                                likes_count: zod.number().nullish(),
                                reads_count: zod.number().nullish(),
                                attached_videos: zod.array(zod.string()).optional(),
                                content_images: zod.array(zod.string()).optional(),
                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                comments_count: zod.number().nullish(),
                                sns_links: zod.array(zod.string().url()).optional(),
                                monthly_rank: zod.number().nullish(),
                                sns_shares: zod.array(zod.string()).optional(),
                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                reviews_count: zod.number().nullish(),
                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                has_user_reviewed: zod.boolean().optional(),
                                review_config: zod
                                    .union([
                                        zod
                                            .object({
                                                review_config_id: zod.number().optional(),
                                                review_config_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemReviewConfigOneReviewConfigNameMax,
                                                    )
                                                    .optional(),
                                                general_description: zod.string().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                        zod.null(),
                                    ])
                                    .optional(),
                                review_questions: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemReviewQuestionsItemQuestionTextThMax,
                                                    )
                                                    .optional(),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemReviewQuestionsItemQuestionTextEnMax,
                                                    )
                                                    .optional(),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemReviewQuestionsItemQuestionTextJaMax,
                                                    )
                                                    .optional(),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional(),
                                                option_th: zod.array(zod.string()).optional(),
                                                option_en: zod.array(zod.string()).optional(),
                                                option_ja: zod.array(zod.string()).optional(),
                                                is_required: zod.number().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                review_data: zod
                                    .union([
                                        zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                answers: zod
                                                    .array(
                                                        zod
                                                            .object({
                                                                review_question_id: zod.number().optional(),
                                                                answer_value: zod.string().optional(),
                                                                question_text_th: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemReviewDataOneAnswersItemQuestionTextThMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_en: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemReviewDataOneAnswersItemQuestionTextEnMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_ja: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemReviewDataOneAnswersItemQuestionTextJaMax,
                                                                    )
                                                                    .optional(),
                                                                question_type: zod.string().optional(),
                                                                option_th: zod.array(zod.string()).optional(),
                                                                option_en: zod.array(zod.string()).optional(),
                                                                option_ja: zod.array(zod.string()).optional(),
                                                                answer_value_th: zod.string().optional(),
                                                                answer_value_en: zod.string().optional(),
                                                                answer_value_ja: zod.string().optional(),
                                                            })
                                                            .strict()
                                                            .describe(
                                                                "Question text\/options\/localized answer values are denormalized onto each answer for display convenience.",
                                                            ),
                                                    )
                                                    .optional(),
                                            })
                                            .strict()
                                            .describe(
                                                "Current user's review data for this post (null if not reviewed)",
                                            ),
                                        zod.null(),
                                    ])
                                    .optional(),
                                ads: zod
                                    .array(
                                        zod
                                            .object({
                                                ad_id: zod.number().optional(),
                                                ad_type: zod
                                                    .enum([
                                                        "PLACE_HOLDER",
                                                        "PRODUCT_LINKER",
                                                        "PRODUCT_LINKER_OGP",
                                                        "PRODUCT_CARD",
                                                        "TOP_BANNER",
                                                        "SECTION_BANNER",
                                                        "USERS_BANNER",
                                                        "USERS_BANNER_RECTANGLE",
                                                        "AUTH_BANNER",
                                                    ])
                                                    .optional(),
                                                image_path: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemImagePathMax,
                                                    )
                                                    .optional(),
                                                ad_title: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemAdTitleMax,
                                                    )
                                                    .optional(),
                                                ad_body: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemAdBodyMax,
                                                    )
                                                    .optional(),
                                                link_url: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemAdsItemLinkUrlMax,
                                                    )
                                                    .optional(),
                                                is_internal_modal_link: zod.boolean().optional(),
                                                modal_board_id: zod.string().nullish(),
                                                modal_post_id: zod.number().nullish(),
                                                ad_product_id: zod.number().nullish(),
                                                display_rate_percent: zod.number().nullish(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Ad item embedded in a home post response"),
                                    )
                                    .optional(),
                                product: zod
                                    .union([
                                        zod
                                            .object({
                                                product_id: zod.number().optional(),
                                                product_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneProductNameMax,
                                                    )
                                                    .optional(),
                                                product_status: zod
                                                    .enum([
                                                        "draft",
                                                        "editing",
                                                        "released",
                                                        "duplicated",
                                                        "rejected",
                                                        "dummy",
                                                        "brand",
                                                    ])
                                                    .optional(),
                                                brand_id: zod.number().nullish(),
                                                brand_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneBrandNameMax,
                                                    )
                                                    .optional(),
                                                category_id: zod.number().nullish(),
                                                category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneCategoryNameMax,
                                                    )
                                                    .optional(),
                                                image_url: zod.string().optional(),
                                                image: zod.string().optional(),
                                                review_count: zod.number().nullish(),
                                                average_rating: zod.number().nullish(),
                                                recommend_rank: zod.number().nullish(),
                                                general_description: zod.string().optional(),
                                                product_note: zod.string().optional(),
                                                product_url: zod.string().optional(),
                                                price: zod.number().nullish(),
                                                price_unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOnePriceUnitMax,
                                                    )
                                                    .optional(),
                                                group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                                unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneUnitMax,
                                                    )
                                                    .optional(),
                                                how_to_use: zod.string().optional(),
                                                ingredients: zod.string().optional(),
                                                keyword: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneKeywordMax,
                                                    )
                                                    .optional(),
                                                created_by: zod.number().nullish(),
                                                updated_by: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod.number().nullish(),
                                                parent_category_id: zod.number().nullish(),
                                                parent_category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneParentCategoryNameMax,
                                                    )
                                                    .optional(),
                                                likes_count: zod.number().nullish(),
                                                comments_count: zod.number().nullish(),
                                                reads_count: zod.number().nullish(),
                                                review_count_guest: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                posts_count_guest: zod.number().nullish(),
                                                positive_points_th: zod.array(zod.string()).optional(),
                                                negative_points_th: zod.array(zod.string()).optional(),
                                                positive_points_en: zod.array(zod.string()).optional(),
                                                negative_points_en: zod.array(zod.string()).optional(),
                                                positive_points_ja: zod.array(zod.string()).optional(),
                                                negative_points_ja: zod.array(zod.string()).optional(),
                                                review_summary_th: zod.string().optional(),
                                                review_summary_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneReviewSummaryEnMax,
                                                    )
                                                    .optional(),
                                                review_summary_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesEditorialReviewsItemProductOneReviewSummaryJaMax,
                                                    )
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Linked product data embedded in a home post response."),
                                        zod.null(),
                                    ])
                                    .optional(),
                                likes: zod
                                    .array(
                                        zod
                                            .object({
                                                like_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                comment_id: zod.number().nullish(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                reads: zod
                                    .array(
                                        zod
                                            .object({
                                                read_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                comments: zod
                                    .array(
                                        zod
                                            .object({
                                                comment_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                content: zod.string().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                board: zod
                                    .object({
                                        board_config_id: zod.number().optional(),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional(),
                                        is_active: zod.number().optional(),
                                        allowed_read_roles: zod.array(zod.string()).optional(),
                                        allowed_write_roles: zod.array(zod.string()).optional(),
                                        allowed_like_roles: zod.array(zod.string()).optional(),
                                        allowed_comment_roles: zod.array(zod.string()).optional(),
                                        comment_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        board_type: zod.enum(["general", "news", "article", "review"]).optional(),
                                        name_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemBoardNameThMax)
                                            .optional(),
                                        name_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemBoardNameEnMax)
                                            .optional(),
                                        name_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemBoardNameJaMax)
                                            .optional(),
                                        description_th: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemBoardDescriptionThMax,
                                            )
                                            .optional(),
                                        description_en: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemBoardDescriptionEnMax,
                                            )
                                            .optional(),
                                        description_ja: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemBoardDescriptionJaMax,
                                            )
                                            .optional(),
                                        list_style: zod.enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"]).optional(),
                                        modal_usage: zod
                                            .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                                            .optional(),
                                        modal_size: zod
                                            .enum(["small", "medium", "large", "extra-large", "N/A"])
                                            .optional(),
                                        title_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        fixed_title: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemBoardFixedTitleMax,
                                            )
                                            .optional(),
                                        product_linker_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        target_product_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        ogp_preview_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        user_info_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        show_content: zod.enum(["SHOW", "HIDE"]).optional(),
                                        rating_overlay_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        date_show: zod.enum(["SHOW", "HIDE"]).nullish(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        review_config_id: zod.number().nullish(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional(),
                                user: zod
                                    .object({
                                        user_id: zod.number(),
                                        display_name: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemUserDisplayNameMax,
                                            )
                                            .optional(),
                                        first_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemUserFirstNameMax)
                                            .optional(),
                                        last_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemUserLastNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemUserNickNameMax)
                                            .optional(),
                                        date_of_birth: zod.string().date().nullish(),
                                        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        skin_concerns: zod.array(zod.string()).optional(),
                                        skin_tone: zod
                                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                            .nullish(),
                                        hair_type: zod
                                            .enum([
                                                "straight_coarse",
                                                "straight_soft",
                                                "wavy_coarse",
                                                "wavy_soft",
                                                "normal_hair",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                        preferred_price_range: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemUserPreferredPriceRangeMax,
                                            )
                                            .optional(),
                                        social_instagram: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialInstagramMax,
                                            )
                                            .optional(),
                                        social_facebook: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialFacebookMax,
                                            )
                                            .optional(),
                                        social_x: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialXMax)
                                            .optional(),
                                        social_tiktok: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialTiktokMax,
                                            )
                                            .optional(),
                                        social_youtube: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialYoutubeMax,
                                            )
                                            .optional(),
                                        social_website: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesEditorialReviewsItemUserSocialWebsiteMax,
                                            )
                                            .optional(),
                                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        review_count: zod.number().nullish(),
                                        avatar: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesEditorialReviewsItemUserAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        followings_count: zod.number().optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("User item for home page sections"),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Post item for home page sections"),
                    )
                    .describe("Latest editorial_reviews board articles"),
                articles_expert_reviews: zod
                    .array(
                        zod
                            .object({
                                post_id: zod.number(),
                                board_id: zod.enum([
                                    "review",
                                    "tiktoks",
                                    "beauty_news",
                                    "editorial_reviews",
                                    "expert_reviews",
                                    "activities",
                                    "test_modal",
                                    "test_modeless",
                                    "guidance",
                                ]),
                                user_id: zod.number(),
                                post_title: zod
                                    .string()
                                    .max(getHomeData200ResponseDataArticlesExpertReviewsItemPostTitleMax)
                                    .optional(),
                                content: zod.string().optional(),
                                post_product_id: zod.number().nullish(),
                                product_brand_name: zod.string().nullish(),
                                product_category_id: zod.number().nullish(),
                                product_category_name: zod.string().nullish(),
                                product_parent_category_id: zod.number().nullish(),
                                product_parent_category_name: zod.string().nullish(),
                                recommend_rank: zod.number().min(1).nullish(),
                                average_rating: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Average review rating (review-board posts only), derived from the post's rating answers. null when the post has no rating answers or is not a review post.\n",
                                    ),
                                attached_images: zod.array(zod.string()).optional(),
                                likes_count: zod.number().nullish(),
                                reads_count: zod.number().nullish(),
                                attached_videos: zod.array(zod.string()).optional(),
                                content_images: zod.array(zod.string()).optional(),
                                delete_flag: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                post_status: zod.enum(["draft", "editing", "released", "rejected"]).optional(),
                                comments_count: zod.number().nullish(),
                                sns_links: zod.array(zod.string().url()).optional(),
                                monthly_rank: zod.number().nullish(),
                                sns_shares: zod.array(zod.string()).optional(),
                                review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                reviews_count: zod.number().nullish(),
                                rating_distribution: zod.record(zod.string(), zod.number()).optional(),
                                has_user_reviewed: zod.boolean().optional(),
                                review_config: zod
                                    .union([
                                        zod
                                            .object({
                                                review_config_id: zod.number().optional(),
                                                review_config_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemReviewConfigOneReviewConfigNameMax,
                                                    )
                                                    .optional(),
                                                general_description: zod.string().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                        zod.null(),
                                    ])
                                    .optional(),
                                review_questions: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                question_text_th: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemReviewQuestionsItemQuestionTextThMax,
                                                    )
                                                    .optional(),
                                                question_text_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemReviewQuestionsItemQuestionTextEnMax,
                                                    )
                                                    .optional(),
                                                question_text_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemReviewQuestionsItemQuestionTextJaMax,
                                                    )
                                                    .optional(),
                                                data_type: zod
                                                    .enum(["rating", "text", "single_select", "multi_select"])
                                                    .optional(),
                                                option_th: zod.array(zod.string()).optional(),
                                                option_en: zod.array(zod.string()).optional(),
                                                option_ja: zod.array(zod.string()).optional(),
                                                is_required: zod.number().optional(),
                                                is_active: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                review_data: zod
                                    .union([
                                        zod
                                            .object({
                                                review_answer_id: zod.number().optional(),
                                                review_config_id: zod.number().optional(),
                                                answers: zod
                                                    .array(
                                                        zod
                                                            .object({
                                                                review_question_id: zod.number().optional(),
                                                                answer_value: zod.string().optional(),
                                                                question_text_th: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesExpertReviewsItemReviewDataOneAnswersItemQuestionTextThMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_en: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesExpertReviewsItemReviewDataOneAnswersItemQuestionTextEnMax,
                                                                    )
                                                                    .optional(),
                                                                question_text_ja: zod
                                                                    .string()
                                                                    .max(
                                                                        getHomeData200ResponseDataArticlesExpertReviewsItemReviewDataOneAnswersItemQuestionTextJaMax,
                                                                    )
                                                                    .optional(),
                                                                question_type: zod.string().optional(),
                                                                option_th: zod.array(zod.string()).optional(),
                                                                option_en: zod.array(zod.string()).optional(),
                                                                option_ja: zod.array(zod.string()).optional(),
                                                                answer_value_th: zod.string().optional(),
                                                                answer_value_en: zod.string().optional(),
                                                                answer_value_ja: zod.string().optional(),
                                                            })
                                                            .strict()
                                                            .describe(
                                                                "Question text\/options\/localized answer values are denormalized onto each answer for display convenience.",
                                                            ),
                                                    )
                                                    .optional(),
                                            })
                                            .strict()
                                            .describe(
                                                "Current user's review data for this post (null if not reviewed)",
                                            ),
                                        zod.null(),
                                    ])
                                    .optional(),
                                ads: zod
                                    .array(
                                        zod
                                            .object({
                                                ad_id: zod.number().optional(),
                                                ad_type: zod
                                                    .enum([
                                                        "PLACE_HOLDER",
                                                        "PRODUCT_LINKER",
                                                        "PRODUCT_LINKER_OGP",
                                                        "PRODUCT_CARD",
                                                        "TOP_BANNER",
                                                        "SECTION_BANNER",
                                                        "USERS_BANNER",
                                                        "USERS_BANNER_RECTANGLE",
                                                        "AUTH_BANNER",
                                                    ])
                                                    .optional(),
                                                image_path: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemImagePathMax,
                                                    )
                                                    .optional(),
                                                ad_title: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemAdTitleMax,
                                                    )
                                                    .optional(),
                                                ad_body: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemAdBodyMax,
                                                    )
                                                    .optional(),
                                                link_url: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemAdsItemLinkUrlMax,
                                                    )
                                                    .optional(),
                                                is_internal_modal_link: zod.boolean().optional(),
                                                modal_board_id: zod.string().nullish(),
                                                modal_post_id: zod.number().nullish(),
                                                ad_product_id: zod.number().nullish(),
                                                display_rate_percent: zod.number().nullish(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Ad item embedded in a home post response"),
                                    )
                                    .optional(),
                                product: zod
                                    .union([
                                        zod
                                            .object({
                                                product_id: zod.number().optional(),
                                                product_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneProductNameMax,
                                                    )
                                                    .optional(),
                                                product_status: zod
                                                    .enum([
                                                        "draft",
                                                        "editing",
                                                        "released",
                                                        "duplicated",
                                                        "rejected",
                                                        "dummy",
                                                        "brand",
                                                    ])
                                                    .optional(),
                                                brand_id: zod.number().nullish(),
                                                brand_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneBrandNameMax,
                                                    )
                                                    .optional(),
                                                category_id: zod.number().nullish(),
                                                category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneCategoryNameMax,
                                                    )
                                                    .optional(),
                                                image_url: zod.string().optional(),
                                                image: zod.string().optional(),
                                                review_count: zod.number().nullish(),
                                                average_rating: zod.number().nullish(),
                                                recommend_rank: zod.number().nullish(),
                                                general_description: zod.string().optional(),
                                                product_note: zod.string().optional(),
                                                product_url: zod.string().optional(),
                                                price: zod.number().nullish(),
                                                price_unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOnePriceUnitMax,
                                                    )
                                                    .optional(),
                                                group_id: zod.union([zod.number(), zod.string()]).nullish(),
                                                unit: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneUnitMax,
                                                    )
                                                    .optional(),
                                                how_to_use: zod.string().optional(),
                                                ingredients: zod.string().optional(),
                                                keyword: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneKeywordMax,
                                                    )
                                                    .optional(),
                                                created_by: zod.number().nullish(),
                                                updated_by: zod.number().nullish(),
                                                monthly_rank: zod.number().nullish(),
                                                manual_score_offset: zod.number().nullish(),
                                                parent_category_id: zod.number().nullish(),
                                                parent_category_name: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneParentCategoryNameMax,
                                                    )
                                                    .optional(),
                                                likes_count: zod.number().nullish(),
                                                comments_count: zod.number().nullish(),
                                                reads_count: zod.number().nullish(),
                                                review_count_guest: zod.number().nullish(),
                                                posts_count: zod.number().nullish(),
                                                posts_count_guest: zod.number().nullish(),
                                                positive_points_th: zod.array(zod.string()).optional(),
                                                negative_points_th: zod.array(zod.string()).optional(),
                                                positive_points_en: zod.array(zod.string()).optional(),
                                                negative_points_en: zod.array(zod.string()).optional(),
                                                positive_points_ja: zod.array(zod.string()).optional(),
                                                negative_points_ja: zod.array(zod.string()).optional(),
                                                review_summary_th: zod.string().optional(),
                                                review_summary_en: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneReviewSummaryEnMax,
                                                    )
                                                    .optional(),
                                                review_summary_ja: zod
                                                    .string()
                                                    .max(
                                                        getHomeData200ResponseDataArticlesExpertReviewsItemProductOneReviewSummaryJaMax,
                                                    )
                                                    .optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict()
                                            .describe("Linked product data embedded in a home post response."),
                                        zod.null(),
                                    ])
                                    .optional(),
                                likes: zod
                                    .array(
                                        zod
                                            .object({
                                                like_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                comment_id: zod.number().nullish(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                                updated_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                reads: zod
                                    .array(
                                        zod
                                            .object({
                                                read_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                comments: zod
                                    .array(
                                        zod
                                            .object({
                                                comment_id: zod.number().optional(),
                                                post_id: zod.number().optional(),
                                                user_id: zod.number().optional(),
                                                content: zod.string().optional(),
                                                created_at: zod.string().datetime({ offset: true }).optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                board: zod
                                    .object({
                                        board_config_id: zod.number().optional(),
                                        board_id: zod
                                            .enum([
                                                "review",
                                                "tiktoks",
                                                "beauty_news",
                                                "editorial_reviews",
                                                "expert_reviews",
                                                "activities",
                                                "test_modal",
                                                "test_modeless",
                                                "guidance",
                                            ])
                                            .optional(),
                                        is_active: zod.number().optional(),
                                        allowed_read_roles: zod.array(zod.string()).optional(),
                                        allowed_write_roles: zod.array(zod.string()).optional(),
                                        allowed_like_roles: zod.array(zod.string()).optional(),
                                        allowed_comment_roles: zod.array(zod.string()).optional(),
                                        comment_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        board_type: zod.enum(["general", "news", "article", "review"]).optional(),
                                        name_th: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemBoardNameThMax)
                                            .optional(),
                                        name_en: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemBoardNameEnMax)
                                            .optional(),
                                        name_ja: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemBoardNameJaMax)
                                            .optional(),
                                        description_th: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemBoardDescriptionThMax,
                                            )
                                            .optional(),
                                        description_en: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemBoardDescriptionEnMax,
                                            )
                                            .optional(),
                                        description_ja: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemBoardDescriptionJaMax,
                                            )
                                            .optional(),
                                        list_style: zod.enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"]).optional(),
                                        modal_usage: zod
                                            .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                                            .optional(),
                                        modal_size: zod
                                            .enum(["small", "medium", "large", "extra-large", "N/A"])
                                            .optional(),
                                        title_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        fixed_title: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemBoardFixedTitleMax)
                                            .optional(),
                                        product_linker_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        target_product_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        ogp_preview_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        user_info_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        show_content: zod.enum(["SHOW", "HIDE"]).optional(),
                                        rating_overlay_show: zod.enum(["SHOW", "HIDE"]).optional(),
                                        date_show: zod.enum(["SHOW", "HIDE"]).nullish(),
                                        review_enabled: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                                        review_config_id: zod.number().nullish(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional(),
                                user: zod
                                    .object({
                                        user_id: zod.number(),
                                        display_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemUserDisplayNameMax)
                                            .optional(),
                                        first_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemUserFirstNameMax)
                                            .optional(),
                                        last_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemUserLastNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemUserNickNameMax)
                                            .optional(),
                                        date_of_birth: zod.string().date().nullish(),
                                        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).nullish(),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        skin_concerns: zod.array(zod.string()).optional(),
                                        skin_tone: zod
                                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                                            .nullish(),
                                        hair_type: zod
                                            .enum([
                                                "straight_coarse",
                                                "straight_soft",
                                                "wavy_coarse",
                                                "wavy_soft",
                                                "normal_hair",
                                                "not_sure",
                                            ])
                                            .nullish(),
                                        hair_scalp_concerns: zod.array(zod.string()).optional(),
                                        beauty_wellness_interests: zod.array(zod.string()).optional(),
                                        lifestyle_environment: zod.array(zod.string()).optional(),
                                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                                        preferred_price_range: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemUserPreferredPriceRangeMax,
                                            )
                                            .optional(),
                                        social_instagram: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialInstagramMax,
                                            )
                                            .optional(),
                                        social_facebook: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialFacebookMax,
                                            )
                                            .optional(),
                                        social_x: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialXMax)
                                            .optional(),
                                        social_tiktok: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialTiktokMax)
                                            .optional(),
                                        social_youtube: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialYoutubeMax,
                                            )
                                            .optional(),
                                        social_website: zod
                                            .string()
                                            .max(
                                                getHomeData200ResponseDataArticlesExpertReviewsItemUserSocialWebsiteMax,
                                            )
                                            .optional(),
                                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                                        recommend_rank: zod.number().nullish(),
                                        review_count: zod.number().nullish(),
                                        avatar: zod
                                            .string()
                                            .max(getHomeData200ResponseDataArticlesExpertReviewsItemUserAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        followings_count: zod.number().optional(),
                                        created_at: zod.string().datetime({ offset: true }).optional(),
                                        updated_at: zod.string().datetime({ offset: true }).optional(),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("User item for home page sections"),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict()
                            .describe("Post item for home page sections"),
                    )
                    .describe("Latest expert_reviews board articles"),
            })
            .strict()
            .describe("Aggregated home page data"),
    })
    .strict();

export const GetHomeData400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        status_code: zod.union([zod.literal(400), zod.literal(500)]),
    })
    .strict();

export const GetHomeData500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        status_code: zod.union([zod.literal(400), zod.literal(500)]),
    })
    .strict();
